import React, { useEffect, useState } from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap";
import Select from "react-select";
import API from "../../helpers/endpointservice";
import axios from "axios";
import $ from "jquery";
import CommonIcon from "../../helpers/icons";
import Toaster from "../../helpers/toaster";
import PaginationComponent from "../../helpers/Pagination";
import LoaderVisible from "../../helpers/loader";
import WarningComponent from "../../helpers/modal";
import LoaderFailed from "../../helpers/loaderFailed";
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";
import moment from "moment";
import CommonCloneModal from "../common/commonCloneModal"

const customStyles = {
  control: (provided) => ({
    ...provided,
    border: "1px solid #D12232",
    width: "100%",
    minWidth: "100%",
  }),
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "noWrap",
    textOverflow: "ellipsis",
  }),
};

const styles = {
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "noWrap",
    textOverflow: "ellipsis",
  })
}


class Coursemaster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "courseCode",
      userRole: "",
      courseCode: "",
      courseProvider: "",
      isSortAscending: true,
      descriptionUrl: false,
      pageNewCount: false,
      currentUser: "",
      isRequestFailed: false,
      isRequestLoader: false,
      postLouQuestion: [],
      louEmptyArray: [],
      height: window.innerHeight,
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      pageCount: 20,
      feedbackId: 2,
      isClicked: false,
      isSubmitTrue: false,
      courseEmpty: false,
      isAdd: false,
      isEdit: false,
      isAddCourse: false,
      pteDeleteList: [],
      louRemarks: "",
      responseID: 0,
      courseList: [],
      courseEmptyArray: [],
      //Errors
      courseCodeError: false,
      courseTitleError: false,
      vendorNameError: false,
      courseDurationError: false,
      skillTypeError: false,
      category1Error: false,
      category2Error: false,
      louError: false,
      pteError: false,
      courseQuestError: false,
      versionLogList: [],
      currentPage: 1,
      perPage: 20,
      totalCount: 0,
      requestCount: 0,
      historyLogList: [],
      approvedocumentsList: [],
      userId: 8,
      CourseCodeHeading: "",
      courseId: "",
      vendorNameList: [],
      vendorName: "",
      vendorNameDefault: [],
      skillTypeList: [],
      skillTypeName: "",
      skillTypeDefault: [],
      pteTypeList: [],
      pteTypeName: [],
      pteTypeDefault: [],
      louTypeList: [],
      louTypeDefault: [],
      louTypeName: "",
      courseQuestList: [],
      courseQuestListDefault: [],
      courseQuestionaireName: "",
      category1Name: "",
      category1List: [],
      category2Name: "",
      category1Default: [],
      category2List: [],
      category2Default: [],
      newCourse: {
        id: 0,
        courseCode: "",
        courseTitle: "",
        courseDuration: "",
        courseDescription: "",
        isCourseDescriptionUrl: false,
        vendorId: 0,
        vendor: [],
        skillTypeId: 0,
        skillType: [],
        category1Id: 0,
        category2Id: 0,
        category1: [],
        category2: [],
        isCertificatePresent: true,
        isAutoapproval: false,
        isTrainingbond: true,
      },
      LOU: [
        {
          questionId: 0,
          question: "",
          isDeleted: false,
        },
      ],
      isEditCourse: false,
      isCourse: false,
      isPte: false,
      courseNameEmpty: false,
      pteQuestionEmpty: false,
      isPteSubmit: false,
      isLouSubmit: false,
      isCourseSubmit: false,
      pteEmptyArray: [],
      courseQuestionData: {},
      courseQuestionnaireDeleteList: [],
      question: [],
      courseQuestionList: [],
      postCourseQuestion: {},
      courseNameInput: "",
      // comments: "",
      pteJobEmptyArray: [],
      pteEmptyArray: [],
      jobEmptyId: [],
      pteJobDeleteList: [],
      louDeleteList: [],
      courseQuestionnaireDeleteList: [],
      isLouApplicable: true,
      isCQApplicable: true,
      isPteApplicable: true,
      // isAgree: false,
      isDontAgree: false,
      duplicateCourse: {},
      duplicatePte: "",
      duplicateCq: "",
      duplicateLou: "",
      editWarning: false,
      searchData: {},
      courseStatusSearch: "",
      courseCodeSearch: "",
      courseTitleSearch: "",
      courseProviderSearch: "",
      cqData: "",
      vendorSearch: [],
      skillSearch: [],
      category1Search: [],
      category2Search: [],
      CourseQuestAnswers: [],
      pteAnswersOption: [],
      pteJobAnswerOption: [],
      isToastError: false,
      courseAdd: [
        {
          questionId: 0,
          question: "",
          isDeleted: false,
        },
      ],
      PTE: [
        {
          questionId: 0,
          question: "",
          isDeleted: false,
        },
      ],
      pteJob: [],
      courseStatus: true,
      courseStatusView: "",
      auditLog: [],
      cloneId: 0,
      limitExceed: {
        courseCode: false,
        courseTitle: false,
        courseDuration: false
      }
    };
    this.courseCodeRef = React.createRef();
    this.courseTitleRef = React.createRef();
    this.courseDurationRef = React.createRef();
    this.vendorNameRef = React.createRef();
    this.skillTypeRef = React.createRef();
    this.category1Ref = React.createRef();
    this.category2Ref = React.createRef();

    this.handleVendorName1 = this.handleVendorName.bind(this);
    this.handleCategory11 = this.handleCategory1.bind(this);
    this.handleCategory22 = this.handleCategory2.bind(this);
    this.handleSkillType1 = this.handleSkillType.bind(this);
  }

  componentDidMount() {
    this.state.isRequestLoader = true;
    let user = localStorage.getItem("UserId");
    let userRole = localStorage.getItem("Role").split(",")[0];
    this.state.userId = user;
    this.getCourseList();
    this.getCategory1List();
    this.getVendorList();
    this.getSkillList();
    this.getCourseQuestAnswers();
    this.getPteAnswerOptions();
    this.getPteJobAnswerOptions();
    this.state.currentUser = userRole;
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    $("body").removeClass("scrollhide");
  }

  getVendorList = () => {
    axios
      .get(API.GET_VENDOR)
      .then((response) => {
        if (response?.status === 200) {
          // this.setState({
          //     vendorNameList: response?.data
          // })
          this.state.vendorNameList = response?.data?.map((vendor) => {
            return {
              value: vendor.id + "," + vendor.vendorName,
              label: (
                <>
                  {/* <img
                                src={VendorNameIcon}
                            /> */}
                  {/* <CommonIcon className="properties-img-2" fileName="VendorNameIcon" /> */}
                  {/* &nbsp; */}
                  <span>{vendor.vendorName}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false, isRequestFailed: true });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getCategory1List = () => {
    axios
      .get(`${API.GET_CATEGORIES}?type=category1`)
      .then((response) => {
        if (response?.status === 200) {
          this.state.category1List = response.data?.map((category1) => {
            return {
              value: category1.id + "," + category1.name,
              label: (
                <>
                  {/* <img
                            src={VendorNameIcon}
                        /> */}
                  {/* <CommonIcon className="properties-img-2" fileName="courseCategoryIcon" />{" "}
                            &nbsp; */}
                  <span>{category1.name}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false, isRequestFailed: true });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getSkillList = () => {
    axios
      .get(API.GET_SKILLS_TYPE)
      .then((response) => {
        if (response?.status === 200) {
          // this.setState({
          //     skillTypeList: response.data
          // })
          this.state.skillTypeList = response?.data?.map((skill) => {
            return {
              value: skill.id + "," + skill.skillName,
              label: (
                <>
                  {/* <img
                            src={VendorNameIcon}
                        /> */}
                  {/* <CommonIcon className="properties-img-2" fileName="skillIcon" /> */}

                  {/* &nbsp; */}
                  <span>{skill.skillName}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false, isRequestFailed: true });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getCourseQuestAnswers = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios
      .get(API.GET_COURSE_QUEST_ANSWERS)
      .then((res) => {
        if (res.status === 200) {
          const evaluationAns = res.data?.map((item) => ({
            id: item.id,
            name: item.name,
          }));

          this.state.CourseQuestAnswers = evaluationAns;
          this.setState({});
        }
      })

  }

  getPteAnswerOptions = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios
      .get(API.GET_EVAL_ANS)
      .then((res) => {
        if (res.status === 200) {
          const pteEvaluationAns = res.data?.map((item) => ({
            id: item.id,
            name: item.name,
          }));
          this.state.pteAnswersOption = pteEvaluationAns;
          this.setState({});
        }
      })
  }

  getPteJobAnswerOptions = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios
      .get(API.GET_SKILL_STATUS)
      .then((res) => {
        if (res.status === 200) {
          const pteJobEvaluationAns = res.data?.map((item) => ({
            id: item.id,
            name: item.name,
          }));
          this.state.pteJobAnswerOption = pteJobEvaluationAns;
          this.setState({});
        }
      })
  }

  fetchPaginationList = (currentPage, perPage) => {
    this.state.isRequestLoader = true;
    this.setState(
      {
        currentPage: currentPage,
        perPage: perPage,
        isSortAscending: this.state.isSortAscending,
        sortBy: this.state.sortBy,
      },
      () => {
        this.getCourseList();
      }
    );
  };

  openCourseCategory = () => {
    this.clearCourseList();
    this.setState(
      {
        isEdit: false,
        isAdd: true,
        isLou: false,
        isAddCourse: true,
        isLouApplicable: true,
        isCQApplicable: true,
        limitExceed: {
          courseCode: false,
          courseTitle: false,
          courseDuration: false
        }
      },
      () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("courseMasterScreen")
        );

        myOffcanvas.show();

        $("body").addClass("scrollhide");
      }
    );
  };

  //Input Text fields
  handleInputAddData = (e, str) => {
    if (e?.target?.value?.length > 0) {
      if (e?.target?.value?.trim()?.length > 250) {
        this.state.limitExceed[str] = true;
      } else if (e?.target?.value?.trim()?.length <= 250) {
        this.state.limitExceed[str] = false;
        const { newCourse } = this.state;
        const value = e.target.value;
        newCourse[str] = value;
        this.state.newCourse = { ...newCourse };
        this.state.courseEmpty = false;
        this.setState({});
      }
    } else {
      const { newCourse } = this.state;
      //const value = e.target.value;
      newCourse[str] = "";
      this.setState({
        newCourse: { ...newCourse },
        courseEmpty: false,
      });
    }
  };
  handleInputAddDataCourseDuration = (e, str) => {
    if (e?.target?.value?.length > 0) {
      if (e?.target?.value?.trim()?.length > 250) {
        this.state.limitExceed[str] = true;
      } else if (e?.target?.value?.trim()?.length <= 250) {
        let exp = new RegExp(/^\d+(\.\d{0,2})?$/)
        if (exp.test(e.target.value)) {
          this.state.limitExceed[str] = false;
          const { newCourse } = this.state;
          const value = e.target.value;
          newCourse[str] = value;
          this.state.newCourse = { ...newCourse };
          this.state.courseEmpty = false;
          this.setState({});
        }
      }
    } else {
      const { newCourse } = this.state;
      //const value = e.target.value;
      newCourse[str] = "";
      this.setState({
        newCourse: { ...newCourse },
        courseEmpty: false,
      });
    }
  };

  handleInputAddCourseUrl = (e, str) => {
    this.state.limitExceed[str] = false;
    const { newCourse } = this.state;
    const value = e.target.value;
    newCourse[str] = value;
    this.state.newCourse = { ...newCourse };
    this.state.courseEmpty = false;
    this.setState({});
  };

  //Radio Buttons
  handleRadioButton = (e, str, type) => {
    const { newCourse } = this.state;
    const value = e.target.value.toLowerCase() === "true";
    if (type === "Add") {
      this.setState((prevState) => ({
        newCourse: {
          ...prevState.newCourse,
          [str]: value,
        },
        // courseEmpty: false
      }));
    }
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }

    this.state.height = window.innerHeight;
    this.setState({});
  };

  getCourseList = () => {
    // document.getElementById("checkBox2").disabled = true;
    // document.getElementById("checkBox1").disabled = true;
    this.state.emptyId = [];
    this.setState({});
    const { currentPage, perPage } = this.state;
    let apiUrl = `${API.GET_COURSE_CATALOGUE}?sortBy=${this.state.sortBy
      }&isSortAscending=${this.state.order == "asc" ? true : false
      }&pageNumber=${currentPage}&pagesize=${perPage}`;

    this.setState({ perPage: perPage });
    axios({
      method: "POST",
      url: apiUrl,
      data: this.state.searchData,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.isRequestLoader = false;
          this.setState({
            courseList: res.data.values,
            pageCount: res.data.totalCount,
            totalCount: res.data.totalCount,
            totalPages: Math.ceil(res.data.totalCount / perPage),
            isRequestLoader: false,
            isRequestFailed: false,
            // sortBy: this.state.sortBy,
            // order: res.data.order,
            isSortAscending: this.state.isSortAscending,
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false, isRequestFailed: true });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  handleAddEditCourse = () => {
    let courseCode = this.state.newCourse.courseCode?.trim();
    let courseTitle = this.state.newCourse.courseTitle?.trim();
    let courseDuration = this.state.newCourse.courseDuration?.trim();
    let vendor = this.state.newCourse.vendor ? this.state.newCourse.vendor : "";
    let skill = this.state.newCourse.skillType ? this.state.newCourse.skillType : "";
    // let lou = this.state.newCourse.louType;
    // let pte = this.state.newCourse.pteType;
    let category1 = this.state.newCourse.category1 ? this.state.newCourse.category1 : "";
    let category2 = this.state.newCourse.category2 ? this.state.newCourse.category2 : "";
    // let courseQuest = this.state.newCourse.courseQuestionaire;

    // CourseCode Validation
    let courseCodeError = courseCode === "";
    this.setState({ courseCodeError });

    // Course Title Validation
    let courseTitleError = courseTitle === "";
    this.setState({ courseTitleError });

    // Course Duration Validation
    let regexp = new RegExp(/^\d+(\.\d{1,2})?$/)
    let courseDurationError = courseDuration === "" || !regexp.test(courseDuration);
    this.setState({ courseDurationError });

    // Vendor Validation
    let vendorNameError = vendor?.length === 0 || vendor === null;
    this.setState({ vendorNameError });

    // Skill Validation
    let skillTypeError = skill?.length === 0 || skill === null;
    this.setState({ skillTypeError });

    // Category1 Validation
    let category1Error = category1?.length === 0 || category1 === null;
    this.setState({ category1Error });

    // Category2 Validation
    let category2Error = category2?.length === 0 || category2 === null;
    this.setState({ category2Error });

    // Check if any error exists
    if (
      courseCodeError ||
      courseTitleError ||
      courseDurationError ||
      vendorNameError ||
      skillTypeError ||
      category1Error ||
      category2Error
    ) {
      // this.focusRef.current.focus();
      // document.getElementById('focusErr').focus();
      if (courseCodeError) {
        this.courseCodeRef.current.focus();
      } else if (courseTitleError) {
        this.courseTitleRef.current.focus();
      } else if (courseDurationError) {
        this.courseDurationRef.current.focus();
      } else if (vendorNameError) {
        this.vendorNameRef.current.focus();
      } else if (skillTypeError) {
        this.skillTypeRef.current.focus();
      } else if (category1Error) {
        this.category1Ref.current.focus();
      } else if (category2Error) {
        this.category2Ref.current.focus();
      }
      this.setState({ isRequestLoader: false })
      return false;
    } else {
      return true;
    }
  };

  postAddEditCourse = () => {
    this.setState({ isRequestLoader: true })
    if (this.state.isAddCourse) {
      this.AddEditCourseList();
    } else {
      if (this.state.courseStatus == false) {
        if (this.handleAddEditCourse() === true) {
          let apiUrl = `${API.STATUS_VALIDATION}?courseId=${this.state.newCourse.id}`;
          axios({
            method: "GET",
            url: apiUrl,
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data == true) {
                  this.state.isRequestLoader = false;
                  toast.error(
                    "Not able to Inactive this course. There is an applied training records for this Course.",
                    {
                      position: toast.POSITION.TOP_RIGHT,
                      color: "#fff",
                    }
                  );
                } else {
                  this.AddEditCourseList();
                }
              }
            })
            .catch((error) => {
              logoutFunction(error?.response?.status);
              console.log(error);
              this.setState({ isRequestLoader: false });
              swal("Error!", "Something went wrong. Please try again.", "warning");
            });
        }
      } else {
        this.AddEditCourseList();
      }
    }
  }

  AddEditCourseList = () => {
    const { newCourse } = this.state;
    let CourseData = {
      id: newCourse.id,
      courseCode: newCourse.courseCode,
      courseTitle: newCourse.courseTitle,
      courseDuration: newCourse.courseDuration,
      courseDescription: newCourse.courseDescription,
      isCourseDescriptionUrl: this.state.descriptionUrl,
      vendorId:
        newCourse.vendor?.value?.split(",")[0] != ""
          ? parseInt(newCourse.vendor?.value?.split(",")[0])
          : 0,
      vendorName: newCourse.vendor?.value?.split(",")[1],
      skillTypeId:
        newCourse.skillType?.value?.split(",")[0] != ""
          ? parseInt(newCourse.skillType?.value?.split(",")[0])
          : 0,
      skillTypeName: newCourse.skillType?.value?.split(",")[1],
      category1Id:
        newCourse.category1?.value?.split(",")[0] != ""
          ? parseInt(newCourse.category1?.value?.split(",")[0])
          : 0,
      category2Id:
        newCourse.category2?.value?.split(",")[0] != ""
          ? parseInt(newCourse.category2?.value?.split(",")[0])
          : 0,
      category1Name: newCourse.category1?.value?.split(",")[1],
      category2Name: newCourse.category2?.value?.split(",")[1],
      isCertificatePresent: newCourse.isCertificatePresent,
      isAutoapproval: newCourse.isAutoapproval,
      isTrainingbond: newCourse.isTrainingbond,
      status: this.state.courseStatus == true ? "Active" : "Inactive",
      isActive: this.state.courseStatus
    };
    if (this.state.isAdd === true && this.state.isSubmitTrue == false) {
      this.state.isRequestLoader = true;
      this.AddCourseList(CourseData);
    } else if (
      this.state.isEdit === true ||
      (this.state.isAdd === true && this.state.isSubmitTrue == true)
    ) {
      if (
        this.state.newCourse.courseCode.toLowerCase() ==
        this.state.courseCode.toLowerCase()
      ) {
        this.state.isRequestLoader = true;
        this.EditCourseList(CourseData);
      } else {
        if (this.handleAddEditCourse() === true) {

          this.state.isRequestLoader = true;
          let existUrl = `${API.EXIST_COURSE}?courseCode=${newCourse.courseCode}`;
          axios.get(existUrl).then((response) => {
            if (!response.data) {
              this.EditCourseList(CourseData);
            } else {
              toast.error(
                "This Course code is already given. Please add another Course code.",
                {
                  position: toast.POSITION.TOP_RIGHT,
                  color: "#fff",
                }
              );
            }
          });
        }

      }
    }
  };

  AddCourseList = (CourseData) => {
    if (this.handleAddEditCourse() === true) {
      const { userId, newCourse } = this.state;

      let existUrl = `${API.EXIST_COURSE}?courseCode=${newCourse.courseCode}`;
      axios.get(existUrl).then((response) => {
        if (!response.data) {
          let apiUrl = `${API.POST_ADD_UPDATE_COURSE}?userId=${this.state.userId}`;
          this.setState({ isRequestLoader: true, isRequestFailed: false });
          axios
            .post(apiUrl, CourseData)
            .then((res) => {
              this.clearSearchFields();
              this.state.courseCode = this.state.newCourse.courseCode;
              this.setState({ isSubmitTrue: true });
              if (res.status === 200) {
                this.state.responseID = res.data;
                this.state.newCourse.id = res.data;
                this.getCourseList();
                this.courseDetails(res.data);
                this.setState({
                  isRequestLoader: false,
                  isRequestFailed: false,
                });
                this.submitToast();
                $("body").addClass("scrollhide");
              }
            })
            .catch((error) => {
              logoutFunction(error?.response?.status);
              console.log(error);
              // toast.error("Failed to add Course", {
              //   position: toast.POSITION.TOP_RIGHT,
              //   color: "#fff",
              // });
              swal("Error!", "Something went wrong. Please try again.", "warning");
              this.setState({
                isRequestLoader: false,
                isRequestFailed: false,
              });
            });
        } else {
          this.setState({ isRequestLoader: false, isRequestFailed: false });

          toast.error(
            "This Course is already given. Please add another Course.",
            {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            }
          );
        }
      });
    }
  };

  EditCourseList = (CourseData) => {
    // if (this.handleAddEditCourse()) {
    if (this.handleAddEditCourse() === true) {
      const { userId } = this.state;
      let apiUrl = `${API.POST_ADD_UPDATE_COURSE}?userId=${userId}`;
      this.setState({ isRequestLoader: true, isRequestFailed: false });
      axios
        .post(apiUrl, CourseData)
        .then((res) => {
          if (res.status === 200) {
            // this.clearSearchFields();
            this.state.duplicateCourse = CourseData;
            this.getCourseList();
            this.courseDetails(CourseData?.id);
            this.state.editWarning = false;
            // if(this.state.isEdit == true ) { this.courseDetails(this.state.responseID)}
            this.editToast();
            this.setState({
              isSubmitTrue: true,
              isRequestLoader: false,
              isRequestFailed: false,
            });
          }
        })
        .catch((error) => {
          logoutFunction(error?.response?.status);
          console.log(error);
          // toast.error("Failed to edit Course", {
          //   position: toast.POSITION.TOP_RIGHT,
          //   color: "#fff",
          // });
          swal("Error!", "Something went wrong. Please try again.", "warning");
          this.setState({
            isRequestLoader: false,
            isRequestFailed: false,
          });
        });
    }
  };

  clearCourseList = () => {
    this.state.courseEmpty = false;
    this.setState({
      newCourse: {
        id: 0,
        courseCode: "",
        courseTitle: "",
        courseDuration: "",
        courseDescription: "",
        isCourseDescriptionUrl: false,
        vendorId: 0,
        vendor: [],
        skillTypeId: 0,
        skillType: [],
        pteId: 0,
        pteType: [],
        louId: 0,
        louType: [],
        category1Id: 0,
        category2Id: 0,
        courseQuestionaireId: 0,
        courseQuestionaire: [],
        category1: [],
        category2: [],
        isCertificatePresent: true,
        isAutoapproval: false,
        isTrainingbond: true,
      },
      courseEmpty: false,
      isSortAscending: true,
      courseCodeError: false,
      courseTitleError: false,
      vendorNameError: false,
      courseDurationError: false,
      courseQuestError: false,
      skillTypeError: false,
      category1Error: false,
      category2Error: false,
      pteError: false,
      louError: false,
      vendorName: "",
      skillName: "",
      louTypeName: "",
      pteTypeName: "",
      category1Name: "",
      category2Name: "",
      courseQuestionaireName: "",
      vendorNameDefault: [],
      skillTypeDefault: [],
      pteTypeDefault: [],
      louTypeDefault: [],
      courseQuestListDefault: [],
      category1Default: [],
      category2Default: [],
      // order: "desc"
    });
  };

  courseDetailsEdit = (id) => {
    this.setState({
      isRequestLoader: true,
      responseID: id,
      isLou: false,
      isAddCourse: false,
      isEditCourse: true,
      isEdit: true,
      isAdd: false,
      vendorNameError: false,
      skillTypeError: false,
      pteError: false,
      louError: false,
      category1Error: false,
      category2Error: false,
      courseQuestError: false,
      limitExceed: {
        courseCode: false,
        courseTitle: false,
        courseDuration: false
      }
    });
    this.courseDetails(id);
  }

  courseDetails = (Id) => {
    // this.clearCourseList();
    // this.state.isRequestLoader = true;
    // this.state.responseID = Id;
    // this.state.isAddCourse = false;
    // this.state.isAdd = false;
    // this.state.isEdit = true;
    // this.state.isEditCourse = true;
    // this.setState({});
    this.setState({
      // isLou: false,
      // isAddCourse: false,
      // isEditCourse: true,
      // isEdit: true,
      // isAdd: false,
      vendorNameError: false,
      skillTypeError: false,
      pteError: false,
      louError: false,
      category1Error: false,
      category2Error: false,
      courseQuestError: false,
    });
    let apiUrl = `${API.GET_COURSE_BY_ID}?id=${Id}`;
    axios
      .get(apiUrl)
      .then((res) => {
        if (res.status === 200) {
          let auditLogTemp = res.data.historyLog;
          this.getCourseQuestionnaireById();
          this.getLouById();
          this.getPteById();
          this.showcourseMasterScreen();
          this.setState(
            {
              // newCourse: GetCourseData,
              duplicateCourse: res.data,
              descriptionUrl: res.data.isCourseDescriptionUrl,
              newCourse: {
                id: res.data.id,
                courseCode: res.data.courseCode,
                courseTitle: res.data.courseTitle,
                courseDuration: res.data.courseDuration,
                courseDescription: res.data.courseDescription,
                isCourseDescriptionUrl: res.data.isCourseDescriptionUrl,
                isCertificatePresent: res.data.isCertificatePresent,
                isTrainingbond: res.data.isTrainingbond,
                isAutoapproval: res.data.isAutoapproval,
                vendorId: res.data.vendorId,
                skillTypeId: res.data.skillTypeId,
                category1Id: res.data.category1Id,
                category2Id: res.data.category2Id,
                vendor: this.state.vendorNameList?.filter(
                  (c) => parseInt(c.value?.split(",")[0]) === res.data?.vendorId
                )[0], //vendorIssue
                skillType: this.state.skillTypeList?.filter(
                  (c) =>
                    parseInt(c.value?.split(",")[0]) === res.data?.skillTypeId
                )[0],
                category1: this.state.category1List?.filter(
                  (c) =>
                    parseInt(c.value?.split(",")[0]) === res.data?.category1Id
                )[0],
                // category2: this.state.category2List?.filter((c) => parseInt(c.value?.split(",")[0]) === res.data?.category2Id)[0]
              },

              //Changeable
              courseStatus: (res.data.status.toLowerCase() === "inactive") ? false : true,
              courseStatusView: res.data.status,
              courseCode: res.data.courseCode,
              vendorName: this.state.newCourse.vendor,
              skillName: this.state.newCourse.skillType,
              louTypeName: this.state.newCourse.louType,
              pteTypeName: this.state.newCourse.pteType,
              category1Name: this.state.newCourse.category1,
              category2Name: this.state.newCourse.category2,
              courseQuestionaireName: this.state.newCourse.courseQuestionaire,
              auditLog: auditLogTemp, //res.data.auditLog || []

              //Error
              vendorNameDefault: this.state.vendorNameList?.filter(
                (c) => parseInt(c.value?.split(",")[0]) === res.data?.vendorId
              ),
              skillTypeDefault: this.state.skillTypeList?.filter(
                (c) =>
                  parseInt(c.value?.split(",")[0]) === res.data?.skillTypeId
              ),
              category1Default: this.state.category1List?.filter(
                (c) =>
                  parseInt(c.value?.split(",")[0]) === res.data?.category1Id
              ),
              category2Default: this.state.category2List?.filter(
                (c) =>
                  parseInt(c.value?.split(",")[0]) === res.data?.category2Id
              ),
            },
            () => {
              this.setState({ isRequestLoader: false });
              this.category2Rendering(this.state.newCourse.category1);
            }
          );
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  //Pagination
  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber }, () => {
      this.fetchPaginationList(pageNumber, this.state.perPage); //pageSize
    });
  };

  editToast = () => {
    toast.success("Course edited successfully", {
      position: toast.POSITION.TOP_RIGHT,
      color: "#fff",
    });
  };

  submitToast = () => {
    toast.success("Course added successfully", {
      position: toast.POSITION.TOP_RIGHT,
      color: "#fff",
    });
  };

  closeProperties = () => {
    this.clearCourseList();
    $("#courseMasterScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    this.state.order = "asc";
    this.setState({
      duplicateCourse: {},
      isAdd: false,
      isEdit: false,
      isAddCourse: false,
      isEditCourse: false,
      isSubmitTrue: false,
      isLouSubmit: false,
      isCourseSubmit: false,
      isPteSubmit: false,
      isLou: false,
      isCourse: false,
      isPte: false,
      louEmptyArray: [],
      pteEmptyArray: [],
      isPteApplicable: true,
      isCQApplicable: true,
      isPteApplicable: true,
      isClicked: false,
      category2List: [],
      courseAdd: [
        {
          questionId: 0,
          question: "",
          isDeleted: false,
        },
      ],
      PTE: [
        {
          questionId: 0,
          question: "",
          isDeleted: false,
        },
      ],
      pteJob: [],
      LOU: [
        {
          questionId: 0,
          question: "",
          isDeleted: false,
        },
      ],
      pteJobEmptyArray: [],
      // comments: "",
      jobEmptyId: [],
      emptyId: [],
      louDeleteList: [],
      pteDeleteList: [],
      courseQuestionnaireDeleteList: [],
      pteJobDeleteList: [],
      descriptionUrl: false,
      newCourse: {
        id: 0,
        courseCode: "",
        courseTitle: "",
        courseDuration: "",
        courseDescription: "",
        isCourseDescriptionUrl: false,
        vendorId: 0,
        vendor: [],
        skillTypeId: 0,
        skillType: [],
        category1Id: 0,
        category2Id: 0,
        courseQuestionaireId: 0,
        courseQuestionaire: [],
        category1: [],
        category2: [],
        isCertificatePresent: true,
        isAutoapproval: true,
        isTrainingbond: true,
      },
      courseEmpty: false,
      isSortAscending: true,
      courseCodeError: false,
      courseTitleError: false,
      vendorNameError: false,
      courseDurationError: false,
      courseQuestError: false,
      skillTypeError: false,
      category1Error: false,
      category2Error: false,
      vendorName: "",
      skillName: "",
      category1Name: "",
      category2Name: "",
      courseQuestionaireName: "",
      vendorNameDefault: [],
      skillTypeDefault: [],
      courseQuestListDefault: [],
      category1Default: [],
      category2Default: [],
      category1Search: [],
      category2Search: [],
      editWarning: false,
      // isAgree: false,
      // isDontAgree: false,
      responseID: 0,
      courseStatus: true,
      courseStatusView: ""
    });
    // this.sortTable(this.state.sortBy)
  };

  handleVendorName = (e) => {
    this.setState({
      newCourse: {
        ...this.state.newCourse,
        vendor: e,
        vendorId: e ? e.value?.split(",")[0] : 0,
      },
    });
  };

  handleSkillType = (e) => {
    this.setState({
      newCourse: {
        ...this.state.newCourse,
        skillType: e,
        skillTypeId: e ? e.value?.split(",")[0] : 0,
      },
    });
  };

  category2Rendering = (selectedOption) => {
    const categoryId = selectedOption ? selectedOption.value.split(",")[0] : 0;

    axios
      .get(`${API.GET_CATEGORIES}?type=category2&category1=${categoryId}`)
      .then((response) => {
        if (response?.status === 200) {
          const category2Options = response.data?.map((category2) => ({
            value: category2.id + "," + category2.name,
            label: (
              <>
                {/* <CommonIcon className="properties-img-2" fileName="courseCategoryIcon" />{" "} */}
                <span>{category2.name}</span>
              </>
            ),
          }));

          this.setState(
            (prevState) => ({
              newCourse: {
                ...prevState.newCourse,
                category1: selectedOption,
                category1Id: categoryId,
              },
              category1Name: selectedOption,
              category1Error: false,
              category2Name: prevState.category2Name,
              category2List: category2Options,
            }),
            () => {
              //Category 2 Value Issue.
              this.setState(
                {
                  newCourse: {
                    ...this.state.newCourse,
                    category2: this.state.newCourse.category2Id
                      ? this.state.category2List?.filter(
                        (c) =>
                          parseInt(c.value?.split(",")[0]) ===
                          this.state.newCourse.category2Id
                      )[0]
                      : "",
                  },
                },
                () => {
                  if (this.state.isAdd == false) {
                    this.setState({ category2Search: this.state.newCourse.category2 })
                  }
                  this.setState({
                    // category2Search: this.state.newCourse.category2,
                    newCourse: {
                      ...this.state.newCourse,
                      category2Id: this.state.newCourse?.category2Id
                        ? this.state.newCourse?.category2?.value?.split(",")[0]
                        : 0,
                    },
                  });
                }
              );
            }
          );
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false, isRequestFailed: true });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  handleCategory1 = (selectedOption) => {
    this.state.newCourse.category2 = "";
    this.state.newCourse.category2Id = 0;
    if (this.state.isAdd == false) {
      this.state.category1Search = selectedOption;
    }
    this.setState({});
    this.category2Rendering(selectedOption);
  };

  handleCategory2 = (e) => {
    this.setState({
      category2Search: this.state.isAdd ? this.state.category2Search : e,
      newCourse: {
        ...this.state.newCourse,
        category2: e,
        category2Id: e ? e.value.split(",")[0] : 0,
      },
    });
  };

  onChangeCourseProvider = (e) => {
    this.state.courseProvider = e.target.value;
  };

  handleCourseQuest = (e) => {
    this.setState({
      newCourse: {
        ...this.state.newCourse,
        courseQuestionaire: e,
      },
    });
  };

  showPte = () => {
    this.state.isRequestLoader = true;

    this.setState({
      louDeleteList: [],
      pteDeleteList: [],
      courseQuestionnaireDeleteList: [],
      pteJobDeleteList: [],
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("courseMasterScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    // if(this.state.isEdit == true){
    //     this.getPteById();
    // }
    this.setState({
      isLou: false,
      isEditCourse: false,
      isCourse: false,
      isPte: true,
      isAddCourse: false,
      emptyId: [],
      jobEmptyId: [],
    });
    setTimeout(() => {
      this.state.isRequestLoader = false;
    }, 1000);
  };

  showCourseQuestionnaire = () => {
    this.state.isRequestLoader = true;
    this.setState({
      louDeleteList: [],
      pteDeleteList: [],
      courseQuestionnaireDeleteList: [],
      pteJobDeleteList: [],
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("courseMasterScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    // if(this.state.isEdit == true){
    //     this.getCourseQuestionnaireById();
    // }
    this.setState({
      isLou: false,
      isEditCourse: false,
      isCourse: true,
      isPte: false,
      isAddCourse: false,
      emptyId: [],
    });
    setTimeout(() => {
      this.state.isRequestLoader = false;
    }, 1000);
  };

  showEditCourse = () => {
    this.state.isRequestLoader = true;
    this.setState({
      louDeleteList: [],
      pteDeleteList: [],
      courseQuestionnaireDeleteList: [],
      pteJobDeleteList: [],
    });
    this.setState({
      isLou: false,
      isEditCourse: true,
      isCourse: false,
      isPte: false,
      isAddCourse: true,
      emptyId: [],
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("courseMasterScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    //   if(this.state.isEdit == true){
    //     this.courseDetails(this.state.responseID);
    // }
    setTimeout(() => {
      this.state.isRequestLoader = false;
    }, 1000);
  };

  showLou = () => {
    this.state.isRequestLoader = true;
    this.setState({
      louDeleteList: [],
      pteDeleteList: [],
      courseQuestionnaireDeleteList: [],
      pteJobDeleteList: [],
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("courseMasterScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    // if(this.state.isEdit == true){
    //     this.getLouById();
    // }
    this.setState({
      isLou: true,
      isEditCourse: false,
      isCourse: false,
      isPte: false,
      isAddCourse: false,
      emptyId: [],
    });
    setTimeout(() => {
      this.state.isRequestLoader = false;
    }, 1000);
  };

  addRow = (name) => {
    this.state.editWarning = false;
    if (name == "LOU") {
      if (this.state.LOU?.length > 0) {
        this.state.LOU = [
          ...this.state.LOU,
          {
            questionId: 0,
            question: "",
            isDeleted: false,
          },
        ];
      } else {
        this.state.LOU = [
          {
            questionId: 0,
            question: "",
            isDeleted: false,
          },
        ];
      }
    } else if (name == "CQ") {
      if (this.state.courseAdd?.length > 0) {
        this.state.courseAdd = [
          ...this.state.courseAdd,
          {
            questionId: 0,
            question: "",
            isDeleted: false,
          },
        ];
      } else {
        this.state.courseAdd = [
          {
            questionId: 0,
            question: "",
            isDeleted: false,
          },
        ];
      }
      this.state.feedbackId = this.state.courseAdd.length + 1;
    } else if (name == "PTE") {
      if (this.state.PTE?.length > 0) {
        this.state.PTE = [
          ...this.state.PTE,
          {
            questionId: 0,
            question: "",
            isDeleted: false,
          },
        ];
      } else {
        this.state.PTE = [
          {
            questionId: 0,
            question: "",
            isDeleted: false,
          },
        ];
      }
    } else if (name == "PTEJOB") {
      if (this.state.pteJob?.length > 0) {
        this.state.pteJob = [
          ...this.state.pteJob,
          {
            questionId: 0,
            question: "",
            isDeleted: false,
          },
        ];
      } else {
        this.state.pteJob = [
          {
            questionId: 0,
            question: "",
            isDeleted: false,
          },
        ];
      }
    }
    this.setState({});
  };

  removeRow = (Id, name) => {
    this.state.editWarning = false;
    if (name == "CQ") {
      if (this.state.courseAdd.length > 1) {
        if (this.state.courseAdd[Id].questionId !== 0) {
          this.state.courseAdd[Id].isDeleted = true;
          this.state.courseQuestionnaireDeleteList.push(
            this.state.courseAdd[Id]
          );
        }
        this.state.courseAdd.splice(Id, 1);
        this.state.feedbackId = this.state.courseAdd.length + 1;
        this.showcourseMasterScreen();
        this.setState({});
      }
    } else if (name == "PTE") {
      if (this.state.PTE.length > 1) {
        if (this.state.PTE[Id].questionId !== 0) {
          this.state.PTE[Id].isDeleted = true;
          this.state.pteDeleteList.push(this.state.PTE[Id]);
        }
        this.state.PTE.splice(Id, 1);
        this.showcourseMasterScreen();
        this.setState({});
      }
    } else if (name == "PTEJOB") {
      if (this.state.pteJob.length > 0) {
        if (this.state.pteJob[Id].questionId !== 0) {
          this.state.pteJob[Id].isDeleted = true;
          this.state.pteJobDeleteList.push(this.state.pteJob[Id]);
        }
        this.state.pteJob.splice(Id, 1);
        this.showcourseMasterScreen();
        this.setState({});
      }
    } else if (name == "LOU") {
      if (this.state.LOU.length > 1) {
        if (this.state.LOU[Id].questionId !== 0) {
          this.state.LOU[Id].isDeleted = true;
          this.state.louDeleteList.push(this.state.LOU[Id]);
        }
        this.state.LOU.splice(Id, 1);
        this.setHeight1();
        this.showcourseMasterScreen();
        this.setState({});
      }
    }
  };

  showcourseMasterScreen = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("courseMasterScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  postCourseQuestionnaire = () => {
    // courseId=${this.state.responseID}
    let apiUrl = `${API.POST_COURSE_QUESTIONS}?courseId=${this.state.responseID}&userId=${this.state.userId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: this.state.postCourseQuestion,
    })
      .then((res) => {
        this.state.isRequestLoader = false;
        if (res.status === 200) {
          // this.state.currentPage = 1;
          this.state.courseQuestionnaireDeleteList = [];
          this.setState({});
        }
        this.getCourseQuestionnaireById();
        if (this.state.isCourseSubmit || this.state.isEdit) {
          toast.success("Course questionnaire edited successfully", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          });
          this.state.isCourseSubmit = true;
        } else if (this.state.isAdd && !this.state.isCourseSubmit) {
          // $("#courseMasterScreen").removeClass("show");
          // $("body").removeClass("scrollhide");
          // this.closeProperties();
          toast.success("Course questionnaire added successfully", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          });
          this.setState({
            isCourseSubmit: true
          })
          this.courseDetails(this.state.responseID);
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.state.isRequestLoader = false;
        console.log(error);
        swal("Error!", "Something went wrong. Please try again.", "warning");
        // if (this.state.isAdd && !this.state.isCourseSubmit) {
        //   toast.error("Failed to add Course Questionnaire", {
        //     position: toast.POSITION.TOP_RIGHT,
        //     color: "#fff",
        //   });
        // } else if (this.state.isCourseSubmit || this.state.isEdit) {
        //   toast.error("Failed to edit Course Questionnaire", {
        //     position: toast.POSITION.TOP_RIGHT,
        //     color: "#fff",
        //   });
        // }
      });
  };

  courseAddSubmit = () => {
    this.state.emptyId = [];
    if (this.state.isCQApplicable == false) {
      this.state.courseAdd = [{
        questionId: 0,
        question: "",
        isDeleted: false,
      },]
      this.state.isRequestLoader = true;
      this.state.postCourseQuestion = {
        isCQApplicable: false,
        // comments: null,
        questions: null,
      };
      this.postCourseQuestionnaire();
    } else {
      this.state.courseAdd.map((item, index) => {
        if (item.question?.trim() == "") {
          this.state.emptyId = [...this.state.emptyId, index];
        }
      });
      // this.state.courseEmptyArray =  this.state.courseAdd.filter((r) => r.question.trim() == "");
      this.setState({});
      // this.state.courseEmptyArray.map((item, index) => {

      //   this.state.emptyId = [...this.state.emptyId , index]
      // })
      if (this.state.emptyId?.length > 0) {
        //   this.setState({ pteQuestionEmpty: true });
      } else {
        this.state.isRequestLoader = true;
        if (this.state.isEdit == true || this.state.isCourseSubmit == true) {
          this.state.postCourseQuestion = {
            isCQApplicable: true,
            // comments: this.state.comments,
            questions: [
              ...this.state.courseAdd,
              ...this.state.courseQuestionnaireDeleteList,
            ],
          };
        } else if (
          this.state.isAdd == true &&
          this.state.isCourseSubmit == false
        ) {
          this.state.postCourseQuestion = {
            isCQApplicable: true,
            // comments: this.state.comments,
            questions: this.state.courseAdd,
          };
        }
        //   courseQuestionaireName: this.state.courseNameInput,

        this.state.pteQuestionEmpty = false;
        this.setState({});
        // $("#addScreen").removeClass("show");
        this.postCourseQuestionnaire();
      }
    }
  };

  courseAddQuestions = (e, id) => {
    if (this.state.courseAdd[id].questionId == 0) {
      // this.state.courseAdd[id].questionId = id + 1;
    }
    this.state.courseAdd[id].question = e.target.value;
    this.setState({});
  };

  postPteEvaluation = () => {
    let apiUrl = `${API.POST_PTE}?courseId=${this.state.responseID}&userId=${this.state.userId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: this.state.pteEvaluationSubmit,
    })
      .then((res) => {
        this.getPteById();
        this.state.isRequestLoader = false;
        if (res.status === 200) {
          this.state.pteDeleteList = [];
          this.state.pteJobDeleteList = [];
          if (this.state.isAdd && !this.state.isPteSubmit) {
            toast.success("PTE added successfully", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
            this.state.isPteSubmit = true;
          } else if (this.state.isPteSubmit || this.state.isEdit) {
            toast.success("PTE edited successfully", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
            this.state.isPteSubmit = true;
          }
          this.setState({});
          this.courseDetails(this.state.responseID);
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.state.isRequestLoader = false;
        // if (this.state.isAdd && !this.state.isPteSubmit) {
        //   toast.error("Failed to add PTE", {
        //     position: toast.POSITION.TOP_RIGHT,
        //     color: "#fff",
        //   });
        // } else if (this.state.isPteSubmit || this.state.isEdit) {
        //   toast.error("Failed to edit PTE", {
        //     position: toast.POSITION.TOP_RIGHT,
        //     color: "#fff",
        //   });
        // }
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
    //   this.closePteProperties();
  };

  pteAddQuestions = (e, id) => {
    if (this.state.PTE[id].questionId == 0) {
      // this.state.PTE[id].questionId = id + 1;
    }
    this.state.PTE[id].question = e.target.value;
    this.setState({});
  };

  louAddQuestions = (e, id) => {
    if (this.state.LOU[id].questionId == 0) {
      // this.state.LOU[id].questionId = id + 1;
    }

    this.state.LOU[id].question = e.target.value;

    this.setState({});
  };

  pteAddJobQuestions = (e, id) => {
    if (this.state.pteJob[id].questionId == 0) {
      // this.state.pteJob[id].questionId = id + 1;
    }
    this.state.pteJob[id].question = e.target.value;
    this.setState({});
  };

  pte1Submit = () => {
    // if(this.state.PTE.length > 0 || this.state.pteJob.length > 0){

    this.state.emptyId = [];
    this.state.jobEmptyId = [];
    if (this.state.isPteApplicable == false) {
      this.state.isRequestLoader = true;
      this.state.PTE = [{
        questionId: 0,
        question: "",
        isDeleted: false,
      },];
      this.state.pteJob = [];
      this.state.pteEvaluationSubmit = {
        isPteApplicable: false,
        pte: null,
        job: null,
      };
      this.postPteEvaluation();
    } else {
      this.state.PTE?.map((item, index) => {
        if (item.question?.trim() == "") {
          this.state.emptyId = [...this.state.emptyId, index];
        }
      });
      this.state.pteJob?.map((item, index) => {
        if (item.question?.trim() == "") {
          this.state.jobEmptyId = [...this.state.jobEmptyId, index];
        }
      });
      // this.state.pteEmptyArray =  this.state.PTE.filter((r) => r.question.trim() == "");
      // this.state.pteJobEmptyArray = this.state.pteJob.filter((r) => r.question.trim() == "");
      this.setState({});
      // this.state.pteJobEmptyArray.map((item, index) => {
      // this.state.jobEmptyId = [...this.state.jobEmptyId , item.questionId]
      //   })
      // this.state.pteEmptyArray.map(( item, index ) => {
      //   this.state.emptyId = [...this.state.emptyId , item.questionId]
      // })
      if (this.state.emptyId?.length > 0 || this.state.jobEmptyId?.length > 0) {
        //   this.setState({ pteQuestionEmpty: true });
      } else {
        if (this.state.isAdd == true && this.state.isPteSubmit == false) {
          if (this.state.PTE?.length > 0) {
            this.state.isRequestLoader = true;
            this.state.pteEvaluationSubmit = {
              isPteApplicable: true,
              pte: [...this.state.PTE],
              job:
                this.state.pteJob?.length > 0 ? [...this.state.pteJob] : null,
            };
            // }else if (this.state.PTE?.length > 0){
            //   this.state.pteEvaluationSubmit = {
            //     pte: [...this.state.PTE],
            //     job: null
            // }
            // }
            // else {
            //   this.state.pteEvaluationSubmit = {
            //     pte: null,
            //     job: [...this.state.pteJob]
            // }
            // this.state.pteQuestionEmpty = false;
            this.setState({});
            this.postPteEvaluation();
          }
        } else if (
          this.state.isEdit == true ||
          this.state.isPteSubmit == true
        ) {
          if (this.state.PTE?.length > 0) {
            this.state.isRequestLoader = true;
            let jobList = [...this.state.pteJob, ...this.state.pteJobDeleteList];
            this.state.pteEvaluationSubmit = {
              isPteApplicable: true,
              pte: [...this.state.PTE, ...this.state.pteDeleteList],
              job: jobList?.length > 0
                ? jobList
                : null,
              // job:
              //   this.state.pteJob?.length > 0
              //     ? [...this.state.pteJob, ...this.state.pteJobDeleteList]
              //     : null,
            };
            // } else if (this.state.PTE?.length > 0){
            //   this.state.pteEvaluationSubmit = {
            //     pte: [...this.state.PTE, ...this.state.pteDeleteList],
            //     job: null
            // }
            // }
            // else {
            //   this.state.pteEvaluationSubmit = {
            //     pte: null,
            //     job: [...this.state.pteJob, ...this.state.pteJobDeleteList]
            // }
            // this.state.pteQuestionEmpty = false;
            this.setState({});
            this.postPteEvaluation();
          }
          // this.state.pteEvaluationSubmit = {
          //     pte: [...this.state.PTE, ...this.state.pteDeleteList],
          //     job: [...this.state.pteJob, ...this.state.pteJobDeleteList]
          // }
        }
      }
      // }
    }
  };

  postLou = () => {
    let apiUrl = `${API.POST_LOU}?courseId=${this.state.responseID}&userId=${this.state.userId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: this.state.postLouQuestion,
    })
      .then((res) => {
        this.getLouById();
        this.state.isRequestLoader = false;
        if (res.status === 200) {
          this.state.louDeleteList = [];
          if (this.state.isAdd && !this.state.isLouSubmit) {
            toast.success("LOU added successfully", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
            this.state.isLouSubmit = true;
          } else if (this.state.isLouSubmit || this.state.isEdit) {
            toast.success("LOU edited successfully", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
            this.state.isLouSubmit = true;
          }
          this.setState({});
          this.courseDetails(this.state.responseID);
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.state.isRequestLoader = false;
        console.log(error);
        // if (!this.state.isLouSubmit && this.state.isAdd) {
        //   toast.error("Failed to add LOU", {
        //     position: toast.POSITION.TOP_RIGHT,
        //     color: "#fff",
        //   });
        // } else if (this.state.isLouSubmit || this.state.isEdit) {
        //   toast.error("Failed to edit LOU", {
        //     position: toast.POSITION.TOP_RIGHT,
        //     color: "#fff",
        //   });
        // }
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  louSubmit = () => {
    this.state.emptyId = [];
    var rmPiece = "__";
    var removeStr = `\\b${rmPiece}\\b`;
    const regex = new RegExp(removeStr, 'g');
    if (this.state.isLouApplicable == false) {
      this.state.isRequestLoader = true;
      this.state.postLouQuestion = {
        isLouApplicable: false,
        // isLouAgree:
        // (this.state.isAgree && true) || (this.state.isDontAgree && false),
        questions: null,
      };
      this.postLou();
    } else {
      this.state.LOU.map(
        (item, index) =>
          (this.state.LOU[index].question = item.question.replace(regex, 'textbox'))
      );
      // this.state.louEmptyArray =  this.state.LOU.filter((r) => r.question.trim() == "");
      this.state.LOU.map((item, index) => {
        if (item.question?.trim() == "") {
          this.state.emptyId = [...this.state.emptyId, index];
        }
        // else {
        // item.question.replaceAll("__" , "textbox")
        // }
      });
      this.setState({});
      if (
        this.state.emptyId?.length > 0 ||
        this.state.LOU?.length == 0
        // || (this.state.isAgree == false && this.state.isDontAgree == false)
      ) {
        //   this.setState({ pteQuestionEmpty: true });
      } else {
        this.state.isRequestLoader = true;

        if (this.state.isAdd) {
          this.state.postLouQuestion = {
            isLouApplicable: true,
            // isLouAgree:
            //   (this.state.isAgree && true) || (this.state.isDontAgree && false),
            questions: [...this.state.LOU],
          };
        } else if (this.state.isEdit) {
          this.state.postLouQuestion = {
            isLouApplicable: true,
            // isLouAgree:
            //   (this.state.isAgree && true) || (this.state.isDontAgree && false),
            questions: [...this.state.LOU, ...this.state.louDeleteList],
          };
        }
        this.setState({});
        this.postLou();
      }
    }
  };

  setHeight = (fieldId) => {
    if (document.getElementById(fieldId).scrollHeight > 85) {
      document.getElementById(fieldId).style.height =
        document.getElementById(fieldId).scrollHeight + "px";
    }
  };

  setHeight1 = () => {
    this.state.LOU.question?.map((item, index) => {
      if (document.getElementById("textBox1" + index).scrollHeight > 85) {
        document.getElementById("textBox1" + index).style.height =
          document.getElementById("textBox1" + index).scrollHeight + "px";
      }
    });
  };

  getPteById = () => {
    let apiUrl = `${API.GET_PTE_BYID}?courseId=${this.state.responseID}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.duplicatePte = res.data;
          // this.state.PTE =
          //   res.data.pte?.length > 0 ? res.data.pte : this.state.PTE;
          res.data?.pte?.map((item, index) => {
            if (index == 0) {
              this.state.PTE = [{
                isDeleted: item.isDeleted,
                question: item.question,
                questionId: item.questionId
              }]
              this.setState({})
            } else {
              this.state.PTE = [...this.state.PTE, {
                isDeleted: item.isDeleted,
                question: item.question,
                questionId: item.questionId
              }]
              this.setState({})
            }
          })
          res.data?.job?.map((item, index) => {
            if (index == 0) {
              this.state.pteJob = [{
                isDeleted: item.isDeleted,
                question: item.question,
                questionId: item.questionId
              }]
              this.setState({})
            } else {
              this.state.pteJob = [...this.state.pteJob, {
                isDeleted: item.isDeleted,
                question: item.question,
                questionId: item.questionId
              }]
              this.setState({})
            }
          })
          // this.state.pteJob = res.data.job;
          this.state.isPteApplicable = res.data.isPteApplicable;
          this.state.isPteSubmit = (res.data.isPteApplicable == null) ? false : true;
          this.state.editWarning = false;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getCourseQuestionnaireById = () => {
    let apiUrl = `${API.GET_COURSE_BYID}?courseId=${this.state.responseID}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.editWarning = false;
          this.state.duplicateCq = res.data;
          // this.state.cqData = res.data;
          // this.state.courseAdd =
          res.data?.questions?.map((item, index) => {
            if (index == 0) {
              this.state.courseAdd = [{
                isDeleted: item.isDeleted,
                question: item.question,
                questionId: item.questionId
              }]
              this.setState({})
            } else {
              this.state.courseAdd = [...this.state.courseAdd, {
                isDeleted: item.isDeleted,
                question: item.question,
                questionId: item.questionId
              }]
              this.setState({})
            }
          })
          // this.state.comments = res.data.comments;
          this.state.feedbackId = this.state.courseAdd.length + 1;
          this.state.isCQApplicable = res.data?.isCQApplicable;
          this.state.isCourseSubmit = (res.data.isCQApplicable == null) ? false : true;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getLouById = () => {
    this.state.LOU = [
      {
        questionId: 0,
        question: "",
        isDeleted: false,
      },
    ]
    let apiUrl = `${API.GET_LOU_BYID}?courseId=${this.state.responseID}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.duplicateLou = res.data;
          // this.state.LOU =
          //   res.data.questions?.length > 0
          //     ? res.data.questions
          //     : this.state.LOU;
          res.data?.questions?.map((item, index) => {
            if (index == 0) {
              this.state.LOU = [{
                isDeleted: item.isDeleted,
                question: item.question,
                questionId: item.questionId
              }]
              this.setState({})
            } else {
              this.state.LOU = [...this.state.LOU, {
                isDeleted: item.isDeleted,
                question: item.question,
                questionId: item.questionId
              }]
              this.setState({})
            }
          })
          this.state.isLouApplicable = res.data.isLouApplicable;
          this.state.isLouSubmit = (res.data.isLouApplicable == null) ? false : true;
          // res.data.isLouAgree
          //   ? this.setState({ isAgree: true, isDontAgree: false })
          //   : this.setState({ isAgree: false, isDontAgree: true });
          var rmPiece = "textbox";
          var removeStr = `\\b${rmPiece}\\b`;
          const regex = new RegExp(removeStr, 'g');
          this.state.editWarning = false;
          if (res.data.isLouApplicable == true) {
            this.state.LOU?.map(
              (item, index) => {
                this.state.LOU[index].question = item.question.replace(regex, '__')
                this.state.duplicateLou.questions[index].question = item.question.replace(regex, '__')
              }

            );
          }
          this.state.isRequestLoader = false;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  toastSubmitWarning = () => {
    let myOffcanvas = new window.bootstrap.Modal(
      document.getElementById("switchTabWarningScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  sortTable = (name) => {
    let sortData = this.state.courseList;
    if (sortData.length !== 0) {
      this.state.isRequestLoader = true;
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }
      this.state.pageNewCount = !this.state.pageNewCount;
      this.setState({ currentPage: 1 }, () => {
        this.getCourseList()
      })
      // this.getCourseList();
    }
  };

  closeCourse = () => {
    $("#courseMasterScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    this.closeProperties();
  };

  closeWithoutWarning = () => {
    this.closeProperties();
    $("#courseMasterScreen").removeClass("show");
    $("body").removeClass("scrollhide");
  };

  closeWithWarning = () => {
    this.state.editWarning = false;
    this.state.duplicateLou.questions?.map((item) => {
      this.state.LOU.map((ind) => {
        if (ind.questionId == 0) {
          this.state.editWarning = true;
        }
        if (ind.questionId == item.questionId) {
          if (
            ind.question?.trim().toLowerCase() !==
            item.question?.trim().toLowerCase()
          ) {
            this.state.editWarning = true;
          }
        }
      });
    });
    this.state.duplicateCq?.questions?.map((item) => {
      this.state.courseAdd.map((ind) => {
        if (ind.questionId == 0) {
          this.state.editWarning = true;
          this.setState({ editWarning: true })
        }
        if (ind.questionId == item.questionId) {
          if (
            ind.question?.trim().toLowerCase() !==
            item.question?.trim().toLowerCase()
          ) {
            this.state.editWarning = true;
          }
        }
      });
    });
    this.state.duplicatePte?.pte?.map((item) => {
      this.state.PTE.map((ind) => {
        if (ind.questionId == 0) {
          this.state.editWarning = true;
        }
        if (ind.questionId == item.questionId) {
          if (
            ind.question?.trim().toLowerCase() !==
            item.question?.trim().toLowerCase()
          ) {
            this.state.editWarning = true;
          }
        }
      });
    });
    this.state.pteJob?.map((ind) => {
      if (ind.questionId == 0) {
        this.state.editWarning = true;
      }
      this.state.duplicatePte?.job?.map((item) => {
        if (ind.questionId == item.questionId) {
          if (
            ind.question?.trim().toLowerCase() !==
            item.question?.trim().toLowerCase()
          ) {
            this.state.editWarning = true;
          }
        }
      });
    });
    if (
      this.state.duplicateCourse?.courseCode == this.state.newCourse?.courseCode &&
      this.state.duplicateCourse?.courseTitle?.toLowerCase() == this.state.newCourse?.courseTitle?.toLowerCase() &&
      this.state.duplicateCourse?.courseDuration?.toLowerCase() == this.state.newCourse.courseDuration?.toLowerCase() &&
      this.state.duplicateCourse?.courseDescription?.toLowerCase() == this.state.newCourse.courseDescription?.trim().toLowerCase() &&
      this.state.duplicateCourse?.isCourseDescriptionUrl == this.state.descriptionUrl &&
      this.state.duplicateCourse?.isCertificatePresent == this.state.newCourse.isCertificatePresent &&
      this.state.duplicateCourse?.isTrainingbond == this.state.newCourse.isTrainingbond &&
      this.state.duplicateCourse?.isAutoapproval == this.state.newCourse.isAutoapproval &&
      this.state.duplicateCourse?.vendorId == this.state.newCourse.vendorId &&
      this.state.duplicateCourse?.skillTypeId == this.state.newCourse?.skillTypeId &&
      this.state.duplicateCourse?.category1Id == this.state.newCourse?.category1Id &&
      this.state.duplicateCourse?.category2Id == this.state.newCourse?.category2Id &&
      this.state.duplicateLou?.isLouApplicable == this.state.isLouApplicable &&
      // this.state.duplicateLou?.isLouAgree ==
      //   ((this.state.isAgree && true) || (this.state.isDontAgree && false)) &&
      // this.state.pteDeleteList?.length == 0 &&
      this.state.pteJobDeleteList?.length == 0 &&
      this.state.louDeleteList?.length == 0 &&
      this.state.courseQuestionnaireDeleteList?.length == 0 &&
      this.state.duplicateCq?.isCQApplicable == this.state.isCQApplicable &&
      this.state.duplicatePte?.isPteApplicable == this.state.isPteApplicable &&
      this.state.duplicateLou?.isLouApplicable == this.state.isLouApplicable &&
      this.state.editWarning == false
    ) {
      this.closeWithoutWarning();
    } else {
      let myOffcanvas = new window.bootstrap.Modal(
        document.getElementById("CancelCourseScreen")
      );
      myOffcanvas.show();
      $("body").addClass("scrollhide");
    }
  };

  handleCheckbox = (name) => {
    if (name == "LOU") {
      if (this.state.isLouApplicable == true || this.state.isLouApplicable == null) {
        this.setState({ isLouApplicable: false });
      } else {
        this.setState({ isLouApplicable: true });
      }
    } else if (name == "PTE") {
      if (this.state.isPteApplicable == true || this.state.isPteApplicable == null) {
        this.setState({ isPteApplicable: false });
      } else {
        this.setState({ isPteApplicable: true });
      }
    } else if (name == "CQ") {
      if (this.state.isCQApplicable == true || this.state.isCQApplicable == null) {
        this.setState({ isCQApplicable: false });
      } else {
        this.setState({ isCQApplicable: true });
      }
    }
  };

  // handleAgreeCheckbox = (e) => {
  // if (e.target.value == "AGREE") {
  //   this.setState({
  //     isDontAgree: false,
  //     isAgree: true,
  //   });
  // } else if (e.target.value == "DONTAGREE") {
  //   this.setState({
  //     isDontAgree: true,
  //     isAgree: false,
  //   });
  // }
  //   this.state.isAgree = e.target.value.toLowerCase(); //already commanded
  // this.setState({});// already commanded
  // };

  openSearchFilter = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("searchScreen")
    );
    myOffcanvas.show();
    this.state.isSearch = true;
    this.state.isFieldEmpty = false;
    $("body").addClass("scrollhide");
  };

  searchCourseMasterList = () => {
    if (
      this.state.courseCodeSearch?.trim().length > 0 ||
      this.state.courseStatusSearch?.trim().length > 0 ||
      this.state.courseTitleSearch?.trim().length > 0 ||
      this.state.courseProviderSearch?.trim().length > 0 ||
      this.state.skillSearch?.value?.split(",")[1]?.trim().length > 0 ||
      this.state.vendorSearch?.value?.split(",")[1]?.trim().length > 0 ||
      this.state.category2Search?.value?.split(",")[1]?.trim().length > 0 ||
      this.state.category1Search?.value?.split(",")[1]?.trim().length > 0
    ) {
      this.setState({
        pageNewCount: !this.state.pageNewCount
      });
      this.state.searchData = {
        courseCode: this.state.courseCodeSearch || null,
        courseTitle: this.state.courseTitleSearch || null,
        activeStatus: this.state.courseStatusSearch || null,
        // courseProvider: this.state.courseProviderSearch || null,
        skills: this.state.skillSearch?.value?.split(",")[1] || null,
        skillId: this.state.skillSearch?.value?.split(",")[0] || 0,
        courseProvider: this.state.vendorSearch?.value?.split(",")[1] || null,
        category1Id: this.state.category1Search?.value?.split(",")[0] || 0,
        category2Id: this.state.category2Search?.value?.split(",")[0] || 0,
        category2Name:
          this.state.category2Search?.value?.split(",")[1] || null,
        category1Name:
          this.state.category1Search?.value?.split(",")[1] || null,
      };
      this.state.currentPage = 1;
      this.state.isRequestLoader = true;
      this.state.isFieldEmpty = false;
      // this.state.isSearch = false;	
      // $("#searchScreen").removeClass("show");	
      $("body").removeClass("scrollhide");
      document.getElementById("closeButton").click();
      this.getCourseList();
    } else {
      this.state.isFieldEmpty = true;
    }
  };

  closeSearchScreen = () => {
    $("body").removeClass("scrollhide");
  };

  clearSearchFields = () => {
    this.state.isRequestLoader = true;
    // $("#searchScreen").removeClass("show");	
    document.getElementById("closeButton").click();
    $("body").removeClass("scrollhide");
    this.setState(
      {
        currentPage: 1,
        pageNewCount: !this.state.pageNewCount,
        searchData: {},
        courseCodeSearch: "",
        courseStatusSearch: "",
        courseTitleSearch: "",
        courseProviderSearch: "",
        skillSearch: [],
        vendorSearch: [],
        category1Search: [],
        category2Search: [],
        category2List: []
      },
      () => this.getCourseList()
    );
  };

  handleChangeToggle = () => {
    this.setState({
      courseStatus: !this.state.courseStatus
    })
  }

  handleChangeClone = (e, item) => {
    if (this.state.cloneId == item.id) {
      this.setState({
        cloneId: 0
      });
    } else {
      this.setState({
        cloneId: item.id
      });
    }
  }

  cloneModalOpen = () => {
    $("#cloneRolesModal").addClass("show");
    $("body").removeClass("scrollhide")
  }

  cloneSuccess = () => {
    this.setState({
      currentPage: 1,
      cloneId: 0
    }, () => {
      this.getCourseList();
    })
  }

  render() {
    const {
      isMobile,
      isRequestFailed,
      isClicked,
      isRequestLoader,
      isSubmitTrue,
      isLouApplicable,
      isCQApplicable,
      isPteApplicable,
      iswebMobile,
      pageCount,
      sortBy,
      order,
      courseList,
      newCourse,
      // isAgree,
      isDontAgree,
      isEdit,
      isAdd,
      isLou,
      isEditCourse,
      isAddCourse,
      isCourse,
      isPte,
      emptyId,
      jobEmptyId,
      isPteSubmit,
      isCourseSubmit,
      isLouSubmit,
      userRole,
      isRadioMobile,
      isSmallMobile,
      // newCourse
    } = this.state;
    let {
      classes,
      actionCommonSearchResult,
      requestCommonSearchResult,
      menuToggle,
      CheckerList,
    } = this.props;
    return (
      <>
        <Toaster />
        {$("#courseMasterScreen").hasClass("show") || $("#searchScreen").hasClass("show") ? (
          <div className="viewbar-overlay "></div>
        ) : (
          <></>
        )}
        <div
          className={`${isMobile
            ? "main-body-mobile"
            : menuToggle
              ? "menu-main-body"
              : "main-body"
            } `}
        >
          <LoaderVisible isLoader={isRequestLoader} />
          {/* <LoaderFailed isLoader={isRequestFailed} /> */}

          <div className="head-fixed ">
            {isMobile == true ? (
              <>
                <div className="mobile-head border-bottom w-100">
                  <div className="col-12 mobile-title">Course master</div>
                </div>
              </>
            ) : (
              <div className="title">
                <CommonIcon fileName="courseMasterActive" />
                <span className="pl-10 head-span ">Course master</span>
              </div>
            )}

            <div
              className={`${isMobile ? "" : ""
                } position-relative border-bottom`}
            >
              <div
                className={`d-flex justify-content-start pl-10 ${menuToggle ? "width-100" : "width-filter"
                  } ${isMobile ? "pr-0" : ""} `}
              >
                <button
                  className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${isSmallMobile ? "pl-5" : ""
                    }`}
                  onClick={() => this.openCourseCategory()}
                >
                  <CommonIcon fileName="addIcon" />
                  <span className={`subhead-span p-2`}>Add</span>
                </button>
                <div
                  className={`position-absolute  end-0 ${isMobile ? "" : menuToggle ? "ml-role-updated" : "ml-role"
                    }`}
                >
                  <span className="cursor-pointer d-flex">
                    {this.state.cloneId > 0 ?
                      <label className="d-flex add-training-icon-course course-icon cursor-pointer mt-2 course-clone-padding" onClick={() => this.cloneModalOpen()}>
                        <CommonIcon fileName="addIcon" />
                        <span className="text-14-bold clone-text-mobile">Clone</span>
                      </label> : ""}
                    <button
                      className="displaybutton"
                      onClick={this.openSearchFilter}
                    >
                      <span>
                        <CommonIcon fileName="filterIcon" />
                      </span>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* <ToastContainer /> */}
          <div
            className={`${isMobile ? "favorite-mobile-table1" : "favorite-table1"
              } table-responsive w-100`} >
            <div className={`table-fixed-header ${(isMobile ? "table-scroll-xy-mobile top-150px" : menuToggle ? "table-scroll-xy-menutoggle top-upcoming-training" : "table-scroll-xy top-upcoming-training")} table-list-view-bottom`} >
              <table
                className={` table fileListTable2 table-borderless table-hover  ${isMobile ? "" : ""
                  } table-responsive `}
              >
                <thead>
                  <tr>
                    <td></td>
                    <td></td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("courseCode")}
                    >
                      <span> Course code </span>
                      {sortBy === "courseCode" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("courseTitle")}
                    >
                      <span>Course title</span>
                      {sortBy === "courseTitle" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("vendorName")}
                    >
                      <span> Course provider</span>
                      {sortBy === "vendorName" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("skillType")}
                    >
                      <span> Skills</span>
                      {sortBy === "skillType" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("category1Name")}
                    >
                      <span> Category 1</span>
                      {sortBy === "category1Name" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("category2Name")}
                    >
                      <span> Category 2</span>
                      {sortBy === "category2Name" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("status")}
                    >
                      <span>Course status </span>
                      {sortBy === "status" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("courseDescription")}
                    >
                      <span> Course description</span>
                      {sortBy === "courseDescription" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>

                  </tr>
                </thead>
                <tbody>
                  {courseList.length !== 0 ? (
                    courseList.map((item, index) => (
                      <tr
                        id={"active" + item.id}
                        key={index}
                        className="requestRadioSelect"
                      >
                        <td></td>
                        <td className="radio-td-width">
                          <input
                            type="checkbox"
                            name="request"
                            checked={
                              this.state.cloneId == item.id
                                ? true
                                : false
                            }
                            onClick={(e) => this.handleChangeClone(e, item)}
                          />
                        </td>
                        <td
                          className="cursor-pointer width-150px"
                          onClick={() => this.courseDetailsEdit(item.id)}
                        >
                          <span>
                            <a className="link">{item.courseCode}</a>
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>{item.courseTitle}</span>
                        </td>
                        <td className="width-150px">
                          <span>{item.vendorName}</span>
                        </td>
                        <td className=" width-150px">
                          <span >{item.skillTypeName}</span>
                        </td>
                        <td className="width-150px">
                          <span>{item.category1Name}</span>
                        </td>
                        <td className="width-150px">
                          <span>{item.category2Name}</span>
                        </td>
                        <td className="width-150px">
                          <span>{item.status}</span>
                        </td>
                        <td className="width-300px">
                          {
                            item.isCourseDescriptionUrl ?
                              <a href={item.courseDescription} className="link" target="_blank">{item.courseDescription}</a> :
                              <span>{item.courseDescription}</span>
                          }
                        </td>

                        {/* <td></td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={10} className="table-nodata">
                        {"No record found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className={`${isMobile
              ? "common-mobilesubmenu mobile-pagination"
              : menuToggle
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
              } pb-2 pt-2`}
          ></div>
        </div>

        {/* View / Edit offcanvas panel  */}
        <div
          className={` ${isEditCourse || isAddCourse
            ? "offcanvasStyle"
            : isLou
              ? "offcanvas-lou mt-48"
              : isCourse
                ? "course_questionnaire_add"
                : isPte
                  ? "pte_add"
                  : ""
            } offcanvas  offcanvas-end  ${this.state.isEditCourse ? "audit-offcanvas" : ''}`}
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="courseMasterScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3 mt-10"
              }`}
          >
            <h6
              id="offcanvasRightLabel"
              className="modal-title pr-10 head-span font-weight-bold"
            >
              {(isEditCourse && isEdit) && this.state.courseCode}
              {(isAddCourse && isAdd) && "Add course"}
              {isLou &&
                (isEdit
                  ? "Edit letter of undertaking"
                  : "Add letter of undertaking")}
              {isPte && (isEdit ? "Edit PTE" : "Add PTE")}
              {isCourse &&
                (isEdit
                  ? "Edit course questionnaire"
                  : "Add course questionnaire")}
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle cross-icon-fixed-1 background-white ${isMobile ? "me-3 mb-3" : "me-3"
                }`}
              onClick={() => {
                if (this.state.isAdd == true) {
                  this.closeWithoutWarning();
                } else if (this.state.isEdit == true) {
                  this.closeWithWarning();
                }
              }}
            //  data-bs-toggle="modal" data-bs-target="#CancelCourseScreen"
            >
              <CommonIcon
                fileName="CrossIcon"
                className="cursor-pointer app-image-hover"
              />
            </button>
          </div>
          <div className="offcanvas-body px-4 pt-0">
            <div
              className={` d-flex text-12-normal pb-2 justify-content-start min-width-heading  `}
            >
              <div
                className={` ${isEditCourse || isAddCourse
                  ? "border-bottom-red"
                  : "border-bottom"
                  } pb-2  cursor-pointer no-wrap`}
                onClick={() => {
                  this.showEditCourse();
                }}
              >
                {/* <label className=""><CommonIcon fileName="EditIcon" /><span className="px-1">Edit course</span></label> */}
                <label className="cursor-pointer">
                  {isEdit &&
                    (isEditCourse ? (
                      <CommonIcon fileName="EditIcon" />
                    ) : (
                      <CommonIcon fileName="edit" />
                    ))}
                  {isAdd &&
                    (isAddCourse ? (
                      <CommonIcon fileName="addIcon" />
                    ) : (
                      <CommonIcon fileName="addCourse" />
                    ))}

                  {/* {(isAddCourse == true) && <CommonIcon fileName="addIcon" />}
                                    {(isAddCourse == false) && <CommonIcon fileName="edit" />} */}
                  <span
                    className={` ${isEditCourse || isAddCourse ? "text-color-red" : ""
                      } px-1`}
                  >
                    {isEdit ? "Edit course" : "Add course"}
                  </span>
                </label>
              </div>
              <div
                className={` ${isLou ? "border-bottom-red" : "border-bottom"
                  } pb-2 cursor-pointer px-2`}
                onClick={() => {
                  if (isSubmitTrue || isEdit) {
                    this.showLou();
                  } else {
                    this.toastSubmitWarning();
                  }
                }}
              // onClick={this.showLou}
              >
                <label className="cursor-pointer">
                  {isLou == true && <CommonIcon fileName="louactiveicon" />}
                  {isLou == false && <CommonIcon fileName="louicon" />}
                  <span className={` ${isLou ? "text-color-red" : ""} px-2`}>
                    LOU
                  </span>
                </label>
              </div>

              <div
                className={` ${isCourse ? "border-bottom-red" : "border-bottom"
                  } cursor-pointer pb-2 cursor-pointer px-2 `}
                onClick={() => {
                  if (isSubmitTrue || isEdit) {
                    this.showCourseQuestionnaire();
                  } else {
                    this.toastSubmitWarning();
                  }
                }}
              // onClick={this.showCourseQuestionnaire}
              >
                <label className="cursor-pointer">
                  <lable>
                    {isCourse == true && <CommonIcon fileName="cqActiveIcon" />}
                  </lable>
                  {isCourse == false && (
                    <CommonIcon fileName="CourseQuestionIcon" />
                  )}
                  <span className={` ${isCourse ? "text-color-red" : ""} px-2`}>
                    CQ
                  </span>
                </label>
              </div>

              <div
                className={` ${isPte ? "border-bottom-red" : "border-bottom"
                  }   pb-2 cursor-pointer px-2 `}
                onClick={() => {
                  if (isSubmitTrue || isEdit) {
                    this.showPte();
                  } else {
                    this.toastSubmitWarning();
                  }
                }}
              // onClick={this.showPte}
              >
                <label className="cursor-pointer">
                  {isPte == true && <CommonIcon fileName="pteActive" />}
                  {isPte == false && <CommonIcon fileName="pteIcon" />}
                  <span className={` ${isPte ? "text-color-red" : ""} px-2`}>
                    PTE
                  </span>
                </label>
              </div>
              {
                // isMobile == false &&
                <div
                  className={` ${(isEditCourse || isAddCourse) && "min-width-editcourse"
                    } ${isLou && "min-width-courseLou"} ${isCourse && "min-width-courseCq"
                    } ${isPte && "min-width-coursePte"} border-bottom`}
                ></div>
              }
            </div>
            {(isEditCourse || isAddCourse) && (
              <div>
                <div className="row">
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text pb-1 ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="CourseCodeIcon"
                        />{" "}
                        <span className="pl-5 properties-span-2">
                          Course code&nbsp;<span className="red-color">*</span>
                        </span>
                        &nbsp;
                        <label className="required"></label>
                      </label>
                      <input
                        type="text"
                        className="form-control form-text-box my-input-class input-box-masterdata"
                        // id="courseCode"
                        id="courseCode"
                        value={newCourse.courseCode && newCourse.courseCode}
                        autocomplete="off"
                        onChange={(e) =>
                          this.handleInputAddData(e, "courseCode")
                        }
                        style={{
                          border: this.state.courseCodeError || this.state.limitExceed.courseCode
                            ? "1px solid #D12232"
                            : "",
                        }}
                        ref={this.courseCodeRef}
                        // readOnly = { this.state.isSubmitTrue}
                        required
                      />
                      {this.state.courseCodeError && (
                        <>
                          {/* <label className="required">Required</label> */}
                        </>
                      )}
                      {this.state.limitExceed.courseCode === true ? (
                        <span className="spanErrMsg">Value must be less than 250 characters</span>
                      ) : (<></>)}
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="CourseTitleIcon"
                        />{" "}
                        <span className="pl-5 properties-span-2 ">
                          Course title&nbsp;<span className="red-color">*</span>
                        </span>
                        <label className="required"></label>
                      </label>
                      <input
                        type="text"
                        className="form-control form-text-box my-input-class input-box-masterdata"

                        id="courseTitle"
                        value={newCourse.courseTitle}
                        placeholder=""
                        style={{
                          border: this.state.courseTitleError || this.state.limitExceed.courseTitle
                            ? "1px solid #D12232"
                            : "",
                        }}
                        onChange={(e) =>
                          this.handleInputAddData(e, "courseTitle")
                        }
                        ref={this.courseTitleRef}
                        // isDisabled = {isSubmitTrue}
                        required
                      />
                      {this.state.courseTitleError && (
                        <>
                          {/* <label className="required">Required</label> */}
                        </>
                      )}
                      {this.state.limitExceed.courseTitle === true ? (
                        <span className="spanErrMsg">Value must be less than 250 characters</span>
                      ) : (<></>)}
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="VendorNameIcon"
                        />
                        <span className="pl-7 properties-span-2">
                          Vendor name&nbsp;<span className="red-color">*</span>
                        </span>
                        <label className="required"></label>
                      </label>
                      <Select
                        className="text-12-normal-select my-input-class select_tag"
                        classNamePrefix="assigngroups"
                        value={newCourse.vendor}
                        options={this.state.vendorNameList}
                        defaultValue={this.state.vendorNameDefault || "Select"}
                        placeholder="Please select an option"
                        isClearable={true}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        styles={this.state.vendorNameError ? customStyles : styles}
                        // isDisabled = {isSubmitTrue}
                        // id={this.state.vendorNameError ? "focusErr" : ""}
                        ref={this.vendorNameRef}
                        onChange={this.handleVendorName}
                      />

                      {this.state.vendorNameError && (
                        <>
                          {/* <label className="required">Required</label> */}
                        </>
                      )}
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="courseDuration"
                        />{" "}
                        <span className="pl-5 properties-span-2 ">
                          Course duration&nbsp;
                          <span className="red-color">*</span>
                        </span>
                        <label className="required"></label>
                      </label>
                      <input
                        type="text"
                        style={{
                          border: this.state.courseDurationError || this.state.limitExceed.courseDuration
                            ? "1px solid #D12232"
                            : "",
                        }}
                        className="form-control form-text-box my-input-class input-box-masterdata"
                        id="courseDuration"
                        value={newCourse.courseDuration}
                        placeholder=""
                        onChange={(e) =>
                          this.handleInputAddDataCourseDuration(e, "courseDuration")
                        }
                        ref={this.courseDurationRef}
                        // readOnly = { this.state.isSubmitTrue}
                        required
                      />
                      {this.state.courseDurationError && (
                        <>
                          {/* <label className="required">Required</label> */}
                        </>
                      )}
                      {this.state.limitExceed.courseDuration === true ? (
                        <span className="spanErrMsg">Value must be less than 250 characters</span>
                      ) : (<></>)}
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="skillIcon"
                        />{" "}
                        <span className="pl-5 properties-span-2">
                          Skill&nbsp;<span className="red-color">*</span>
                        </span>
                        <label className="required"></label>
                      </label>
                      <Select
                        className="text-12-normal-select my-input-class"
                        classNamePrefix="assigngroups"
                        value={newCourse.skillType}
                        options={this.state.skillTypeList}
                        placeholder="Please select an option"
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        styles={this.state.skillTypeError ? customStyles : styles}
                        // id={this.state.skillTypeError ? "focusErr" : ""}
                        ref={this.skillTypeRef}
                        // isDisabled = {isSubmitTrue}
                        onChange={this.handleSkillType} //ArunPending
                      />
                      {this.state.skillTypeError && (
                        <>
                          {/* <label className="required">Required</label> */}
                        </>
                      )}
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="courseCategoryIcon"
                        />{" "}
                        <span className="pl-7 properties-span-2">
                          Category 1&nbsp;<span className="red-color">*</span>
                        </span>
                        <label className="required"></label>
                      </label>
                      <Select
                        className="text-12-normal-select my-input-class"
                        classNamePrefix="assigngroups"
                        value={newCourse.category1}
                        options={this.state.category1List}
                        defaultValue={this.state.category1Default}
                        placeholder="Please select an option"
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        styles={this.state.category1Error ? customStyles : styles}
                        // id={this.state.category1Error ? "focusErr" : ""}
                        ref={this.category1Ref}
                        // isDisabled = {isSubmitTrue}
                        onChange={this.handleCategory1} //ArunPending
                      />
                      {this.state.category1Error && (
                        <>
                          {/* <label className="required">Required</label> */}
                        </>
                      )}
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="courseCategoryIcon"
                        />{" "}
                        <span className="pl-7 properties-span-2">
                          Category 2&nbsp;<span className="red-color">*</span>
                        </span>
                        <label className="required"></label>
                      </label>
                      <Select
                        className="text-12-normal-select my-input-class"
                        classNamePrefix="assigngroups"
                        value={newCourse.category2}
                        options={this.state.category2List}
                        placeholder="Please select an option"
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        styles={this.state.category2Error ? customStyles : styles}
                        // id={this.state.category2Error ? "focusErr" : ""}
                        ref={this.category2Ref}
                        onChange={this.handleCategory2} //ArunPending
                      // isDisabled={!this.state.category1Name || isSubmitTrue}
                      />
                      {this.state.category2Error && (
                        <>
                          {/* <label className="required">Required</label> */}
                        </>
                      )}
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="courseDescIcon"
                        />{" "}
                        <span className="pl-5 properties-span-2">
                          Course description / URL
                        </span>
                        <label className="required"></label>
                      </label>
                      <textarea
                        className="form-control form-text-box-textarea text-wrap"
                        id="courseDescription"
                        rows="3"
                        cols="5"
                        value={newCourse.courseDescription}
                        onChange={(e) =>
                          this.handleInputAddCourseUrl(e, "courseDescription")
                        }
                      // readOnly= { this.state.isSubmitTrue}
                      ></textarea>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <label
                      className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <div className="d-flex border-red">
                        <div
                          className={`px-2 py-1 cursor-pointer  ${!this.state.descriptionUrl
                            ? "bg-danger text-white"
                            : "text-danger"
                            }`}
                          onClick={() => {
                            {
                              this.setState({
                                isClicked: false,
                                descriptionUrl: false,
                              });
                            }
                          }}

                        // onChange={(e) => this.handleInputAddData(e,"")}
                        >
                          {/* <CommonIcon className="properties-img-2 cursor-pointer" fileName="courseDescIcon" />
                                                        <label style={{marginLeft: "5px"}} className="cursor-pointer">Text</label> */}
                          {isClicked === false && !this.state.descriptionUrl ? (
                            <span>
                              <CommonIcon
                                className="properties-img-2"
                                fileName="textCourse"
                              />
                            </span>
                          ) : (
                            <span>
                              <CommonIcon
                                className="properties-img-2"
                                fileName="textCourseRed"
                              />
                            </span>
                          )}
                        </div>
                        <div
                          className={`px-2 py-1 cursor-pointer h-32 ${this.state.descriptionUrl
                            ? "bg-danger text-white"
                            : ""
                            }`}
                          onClick={() => {
                            {
                              this.setState({
                                isClicked: true,
                                descriptionUrl: true,
                              });
                            }
                          }}
                        >
                          {isClicked === false && !this.state.descriptionUrl ? (
                            <span>
                              <CommonIcon
                                className="properties-img-2"
                                fileName="url"
                              />
                            </span>
                          ) : (
                            <span>
                              <CommonIcon
                                className="properties-img-2"
                                fileName="urlWhite"
                              />
                            </span>
                          )}
                        </div>
                      </div>
                    </label>
                  </div>

                  {/* Radio Buttons */}
                  <div className={`col-12 mt-2 ${isMobile ? "pt-2" : ""} `}>
                    <div className="form-group">
                      <label className={`d-flex m-0 label-text flex-column`}>
                        <div>
                          <CommonIcon
                            className="properties-img-2"
                            fileName="successTick"
                          />
                          <span className="pl-5 properties-span-2">
                            Auto approval
                          </span>
                        </div>
                      </label>
                    </div>

                    <div
                      className="form-group label-text mt-1"
                      onChange={(e) => {
                        {
                          this.handleRadioButton(e, "isAutoapproval", "Add");
                        }
                      }}
                    >
                      <input
                        className="height"
                        type="radio"
                        name="isAutoApproval"
                        value="True"
                        checked={newCourse.isAutoapproval}

                      // readonly={isSubmitTrue && "readonly"}
                      />{" "}
                      <label className={`${isMobile ? "pl-3" : "pl-5"}`}>
                        Yes
                      </label>
                      <input
                        className="height ml-10"
                        type="radio"
                        name="isAutoApproval"
                        value="False"
                        checked={newCourse.isAutoapproval == false}
                      // onClick={(e) =>{if(isSubmitTrue == false) {this.handleRadioButton(e, "isAutoapproval", "Add")}}}
                      // readonly={isSubmitTrue && "readonly"}
                      />{" "}
                      <label className={`${isMobile ? "pl-3" : "pl-5"}`}>
                        No
                      </label>
                    </div>
                    <label className="required"></label>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 `}
                  >
                    <div>
                      <label className={`d-flex m-0 label-text flex-column `}>
                        <div>
                          <CommonIcon
                            className="properties-img-2"
                            fileName="certificateCourseCatalogue"
                          />
                          <span className="pl-5 properties-span-2">
                            Certificate
                          </span>
                        </div>
                      </label>
                    </div>
                    <div
                      className="label-text mt-1"
                      onChange={(e) => {
                        {
                          this.handleRadioButton(
                            e,
                            "isCertificatePresent",
                            "Add"
                          );
                        }
                      }}
                    >
                      <input
                        className="height"
                        type="radio"
                        name="isCertificatePresent"
                        value="TRue"
                        checked={newCourse.isCertificatePresent}
                      />{" "}
                      <label className={`${isMobile ? "pl-3" : "pl-5"}`}>
                        Yes
                      </label>
                      <input
                        className="height ml-10"
                        type="radio"
                        name="isCertificatePresent"
                        value="FAlse"
                        checked={!newCourse.isCertificatePresent}
                      // onChange={(e) => { if(isSubmitTrue == false)this.handleRadioButton(e, "isCertificatePresent", "Add")}}
                      />{" "}
                      <label className={`${isMobile ? "pl-3" : "pl-5"}`}>
                        No
                      </label>
                    </div>
                    <label className="required"></label>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 `}
                  >
                    <div>
                      <label className={`d-flex m-0 label-text flex-column `}>
                        <div>
                          <CommonIcon
                            className="properties-img-2"
                            fileName="trainingbondicon"
                          />
                          <span className="pl-5 properties-span-2">
                            Training bond applicable
                          </span>
                        </div>
                      </label>
                    </div>

                    <div
                      className="label-text mt-1"
                      onChange={(e) => {
                        {
                          this.handleRadioButton(e, "isTrainingbond", "Add");
                        }
                      }}
                    >
                      <input
                        className="height"
                        type="radio"
                        name="isTrainingbond"
                        value="TRUe"
                        checked={newCourse.isTrainingbond}
                      />{" "}
                      <label className={`${isMobile ? "pl-3" : "pl-5"}`}>
                        Yes
                      </label>
                      <input
                        className="height ml-10"
                        type="radio"
                        name="isTrainingbond"
                        value="FALse"
                        checked={!newCourse.isTrainingbond}
                      // onChange={(e) => { if(isSubmitTrue == false)this.handleRadioButton(e, "isCertificatePresent", "Add")}}
                      />{" "}
                      <label className={`${isMobile ? "pl-3" : "pl-5"}`}>
                        No
                      </label>
                    </div>
                    <label className="required"></label>
                  </div>

                  <div className={isMobile ? "col-12" : "col-12"}>

                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <CommonIcon
                        className="properties-img-2"
                        fileName="MyselfIcon"
                      />
                      <span className="pl-5 properties-span-2">
                        Status&nbsp;
                      </span>
                      &nbsp;
                    </label>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 d-flex`}
                  >
                    <div class={` ${"form-check form-switch"}`}>
                      <input class={`${"form-check-input toggle-button"}`} type="checkbox" role="switch" id="flexSwitchCheckChecked" onChange={(e) => this.handleChangeToggle(e)} checked={this.state.courseStatus} />
                    </div>
                    <label class={`mt-1 pl-10 view-text`}
                    // for={this.state.allowDisable == false ? "" : "flexSwitchCheckChecked"}
                    >
                      {this.state.courseStatus == true ? "Active" : "Inactive"}</label>
                  </div>
                  {
                    <div className="row">
                      <div
                        className={`${iswebMobile ? "col-12" : "col-6 pl-0"
                          } col-sm-7 col-md-7 col-lg-7 col-xl-7 mb-3 ${iswebMobile
                            ? "mt-2"
                            : isMobile
                              ? "mt-4 ml-8"
                              : "mt-2 ml-8"
                          } `}
                      >
                        {/* <button className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`} onClick={() => this.AddEditCourseList()}>
                                            <span className="model-label pl-5">Next</span>
                                                <span className="mx-2"><CommonIcon fileName="NextArrowIcon" className="modal-img"></CommonIcon></span>
                                            </button> */}
                        <button
                          className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`}
                          onClick={() => {
                            this.postAddEditCourse();
                          }}
                        >
                          <CommonIcon
                            fileName="ButtonSubmitIcon"
                            className="modal-img"
                          ></CommonIcon>
                          <span className="model-label pl-5">
                            {/* {isSubmitTrue ? "Update" : "Submit"} */}
                            {(isSubmitTrue || isEdit) ? "Update" : "Submit"}
                          </span>
                        </button>
                      </div>
                    </div>
                  }
                  {
                    (this.state.isEdit) && this.state.auditLog?.length > 0 && <div>
                      <div className="">
                        <h6 className="modal-title">Audit log</h6>
                      </div>
                      <div className="audit-table-wrapper audit-scroll-css">
                        <table className="px-3 audit-table w-100">
                          <thead>
                            <tr className="border-bottom">
                              <th className="p-rem">
                                Action
                              </th>
                              <th className="p-rem">
                                Action By
                              </th>
                              <th className="p-rem wid-45">
                                Description
                              </th>
                              <th className="p-rem">
                                Date
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              this.state.auditLog?.map((x, i) => (
                                <tr className="border-bottom" key={i}>
                                  <td className="p-rem" key={`${i}-action`}>{x.action ? x.action : "-"}</td>
                                  <td className="p-rem" key={`${i}-actionby`}>{x.actionBy ? x.actionBy : "-"}</td>
                                  <td className="p-rem" key={`${i}-desc`}>
                                    {x.description ? x.description : "-"}
                                  </td>
                                  <td className="p-rem" key={`${i}-created`}>
                                    {x.createdTime ? moment.utc(x.createdTime).local().format("DD-MMM-YYYY, hh:mm A") : "-"}
                                  </td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  }
                </div>
              </div>
            )}
            {isLou && (
              <div>
                {(isLouApplicable || (isLouApplicable == null)) && (
                  <>
                    <div
                      className={`${iswebMobile ? "col-12" : "col-12 pl-0"} ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                        } `}
                    >
                      <div className="row ">
                        <div className={`col-12 pr-10`}>
                          <div
                            className={`${iswebMobile ? "col-12" : "col-12 pl-0"
                              } col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                              }  `}
                          >
                            <button
                              className={`btn question-add-button `}
                              onClick={() => {
                                {
                                  this.addRow("LOU");
                                }
                              }}
                            >
                              <CommonIcon
                                fileName="vendoraddIcon"
                                className="modal-img"
                              />
                              <span className="model-label pl-5 ">Add</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* </div> */}

                    {/* table */}
                    <div className={` mt-2 ${isMobile ? "" : "pb-3"}`}>
                      <div className={`${isMobile && "table-responsive table-responsive-scroll"}`}>
                        <table className="min-width-courseLouCq">
                          <thead>
                            <tr className="border-top height-course">
                              <th className=" slno text-12-bold border-right border-left pl-5px">
                                S.no
                              </th>
                              <th className="lou-question text-12-bold border-left pl-5px"></th>
                              <th className="border-right"></th>
                            </tr>
                          </thead>
                          <tbody className="border-bottom">
                            {this.state.LOU?.length > 0 ? (
                              this.state.LOU.map((item, index) => (
                                <>
                                  <tr id={index}>
                                    <td className="col-1 text-12-bold mt-2 border-right border-left pl-10 pb-85 pt-2 ">
                                      {index + 1}
                                    </td>
                                    <td className="col-9 mt-2 pl-10 text-12-normal-400">
                                      <textarea
                                        className={`lou-length form-text-box2 border-radius-0  ${isMobile
                                          ? "form-control form-control-mobile"
                                          : "form-control"
                                          } text-12-normal-400 `}
                                        style={{
                                          borderColor:
                                            this.state.emptyId?.includes(index)
                                              ? "#d12232"
                                              : "",
                                        }}
                                        id={"textBox1" + index}
                                        rows="3"
                                        // onInput={}
                                        // onKeyUp={this.setHeight('textBox1'  + index)}
                                        onChange={(e) => {
                                          this.louAddQuestions(e, index);
                                          this.setHeight("textBox1" + index);
                                        }}
                                        value={item.question}
                                      // readOnly = {this.state.isLouSubmit}
                                      >
                                        {item.question}
                                      </textarea>
                                    </td>

                                    <td className="col-2 border-right pl-10  position-relative ">
                                      <button
                                        className={`text-reset offcavasclose small-cross-icon mt-2 pt-2 position-absolute top-0 end-0 mx-2 ${isMobile ? "pr-0" : ""
                                          }`}
                                        onClick={() => {
                                          {
                                            this.removeRow(index, "LOU");
                                          }
                                        }}
                                      >
                                        {this.state.LOU?.length > 1 &&
                                          <CommonIcon
                                            fileName="smallCrossIcon"
                                            className={`cursor-pointer ${isMobile ? "" : " app-image-hover"
                                              }`}
                                          />}
                                      </button>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : (
                              <tr>
                                <td className="border-right border-left"></td>
                                <td
                                  colSpan={7}
                                  className="table-nodata text-center border-right p-2"
                                >
                                  {"No record found"}
                                </td>
                              </tr>
                            )}
                            <tr className="border-right border-left text-12-normal-400">
                              <td></td>
                              <td
                                className="border-left pl-10 pb-3"
                                onChange={(e) => {
                                  {
                                    this.handleAgreeCheckbox(e);
                                  }
                                }}
                              >
                                <input
                                  type="checkbox"
                                  name="terms"
                                  value="AGREE"
                                  id="checkBox1"
                                  disabled="true"
                                //  onClick={(e) => {if(isLouSubmit == false) {this.handleAgreeCheckbox(e)}}}
                                // checked={isAgree}
                                />
                                <span className="mx-3">I agree</span>
                                <br></br>
                                <input
                                  type="checkbox"
                                  name="terms"
                                  value="DONTAGREE"
                                  id="checkBox2"
                                  disabled="true"
                                // onClick={(e) => {if(isLouSubmit == false) {this.handleAgreeCheckbox(e)}}}
                                // checked={isDontAgree}
                                ></input>
                                <span className="mx-3">I don't agree</span>
                              </td>
                            </tr>
                            <tr className="border-right border-left text-12-normal-400">
                              <td className="border-left"></td>
                              <td className="border-left">
                                {/* {emptyId?.length > 0 ? (
                                                  <span className="send-rework-label">
                                                    All field is required
                                                  </span>
                                                ) : (
                                                  <></>
                                                )} */}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                )}
                <div className={` ${isMobile ? "mt-2" : ""} `}>
                  <input
                    type="checkbox"
                    name="terms"
                    value="lou"
                    checked={isLouApplicable == false}
                    onClick={() => {
                      {
                        this.handleCheckbox("LOU");
                      }
                    }}
                  ></input>
                  <span className="mx-2  text-12-bold">LOU not applicable</span>
                </div>
                {
                  <div className="row mt-1">
                    <div
                      className={`${iswebMobile ? "col-12" : "col-6 pl-0"
                        } col-sm-7 col-md-7 col-lg-7 col-xl-7 mb-3 ${iswebMobile
                          ? "mt-2"
                          : isMobile
                            ? "mt-4 ml-8"
                            : "mt-2 ml-8"
                        } `}
                    >
                      {/* {
                                    isAdd && 
                                    <button className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`} onClick={() => {if((this.state.LOU?.length > 0) || (isLouApplicable == false)) { this.louSubmit()}}}>
                                    <span className="model-label pl-5">Next</span>
                                <span className="mx-2"><CommonIcon fileName="NextArrowIcon" className="modal-img"></CommonIcon></span>
                                </button>
                                  } */}
                      {/* {
                                    isEdit &&  */}
                      <button
                        className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`}
                        onClick={() => {
                          if (
                            this.state.LOU?.length > 0 ||
                            isLouApplicable == false
                          ) {
                            this.louSubmit();
                          }
                        }}
                      >
                        <CommonIcon
                          fileName="ButtonSubmitIcon"
                          className="modal-img"
                        ></CommonIcon>
                        <span className="model-label pl-5">
                          {(isLouSubmit) ? "Update" : "Submit"}
                        </span>
                      </button>
                      {/* } */}
                    </div>
                  </div>
                }
              </div>
            )}
            {isCourse && (
              <div>
                <div>
                  <div className="row ">
                    {(isCQApplicable == true || isCQApplicable == null) && (
                      <>
                        {/* Add button */}
                        <div className={`col-12 pr-10`}>
                          <div
                            className={`${iswebMobile ? "col-12" : "col-12 pl-0"
                              } col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                              } `}
                          >
                            <button
                              className={`btn question-add-button`}
                              onClick={() => {
                                {
                                  this.addRow("CQ");
                                }
                              }}
                            >
                              <CommonIcon
                                fileName="vendoraddIcon"
                                className="modal-img"
                              />
                              <span className="model-label pl-5">Add</span>
                            </button>
                          </div>
                        </div>

                        {/* table */}
                        <div
                          className={` mt-2 ${isMobile ? "" : "pb-3"} row  `}
                        >
                          <div className={`${isMobile && "table-responsive table-responsive-scroll"}`}>
                            <table className="course-table-width-course ">
                              <>
                                <thead>
                                  <tr className="border-top height-course">
                                    <th className="col-1 mt-2 text-12-bold border-right border-left pl-10">
                                      <span>S.no</span>
                                    </th>
                                    <th className="col-6 mt-2 cq-box border-right border-left pl-10 pb-20"></th>
                                    <th className="col-4 levelofskill-cq mt-2 border-left pl-10 pb-20"></th>
                                    <th className="col-1 mt-0 border-right pl-10 pb-20"></th>
                                  </tr>
                                </thead>
                                <tbody className="border-bottom ">
                                  {this.state.courseAdd?.length > 0 ? (
                                    this.state.courseAdd.map((item, index) => (
                                      <>
                                        <tr key={index + "CQ"}>
                                          <td className="col-1 text-12-bold mt-2 border-right border-left pl-10 pb-100 ">
                                            {index + 1}
                                          </td>
                                          <td className="col-6  cq-box mt-2 border-right border-left pl-10 pr-10 pb-20 text-12-normal-400">
                                            <textarea
                                              className={`text-wrap  form-text-box2 resize-none border-radius-0 ${isMobile
                                                ? "form-control form-control-mobile"
                                                : "form-control"
                                                }`}
                                              rows="3"
                                              style={{
                                                borderColor:
                                                  this.state.emptyId?.includes(
                                                    index
                                                  )
                                                    ? "#d12232"
                                                    : "",
                                              }}
                                              onChange={(e) => {
                                                this.courseAddQuestions(
                                                  e,
                                                  index
                                                );
                                              }}
                                              value={item.question}
                                            // readOnly = {this.state.isCourseSubmit}
                                            >
                                              {item.question}
                                            </textarea>
                                          </td>
                                          <td
                                            className={`col-4 mt-2 pl-10 pb-20 text-wrap text-12-normal-400 ${isMobile
                                              ? "form-control-mobile"
                                              : ""
                                              }`}
                                          >
                                            {this.state.CourseQuestAnswers?.map((courseOption) => (
                                              <>
                                                <input
                                                  className="height "
                                                  type="radio"
                                                  name="test"
                                                  disabled
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    } label-text`}
                                                >
                                                  {courseOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            ))}
                                          </td>
                                          <td className="col-1 border-right pl-10 pb-95">
                                            <button
                                              className={`text-reset  small-cross-icon ${isMobile ? "pr-0" : ""
                                                }`}
                                              onClick={() => {
                                                {
                                                  this.removeRow(index, "CQ");
                                                }
                                              }}
                                            >
                                              {this.state.courseAdd?.length > 1 &&
                                                <CommonIcon
                                                  fileName="smallCrossIcon"
                                                  className={`cursor-pointer ${isMobile
                                                    ? ""
                                                    : " app-image-hover"
                                                    }`}
                                                />}
                                            </button>
                                          </td>
                                        </tr>
                                      </>
                                    ))
                                  ) : (
                                    <tr>
                                      <td className="border-right border-left"></td>
                                      <td
                                        colSpan={7}
                                        className="table-nodata text-center border-right p-2"
                                      >
                                        {"No record found"}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </>
                            </table>
                            {/* {this.state.courseAdd?.length > 0 && (
                              <tabel className="course-table-width-course">
                                <tbody className="border-bottom ">
                                  <tr className="border-top height-course">
                                    <td
                                      className="col-1 sl-no pl-10 text-12-bold border-left border-bottom pb-80"
                                      value={this.state.feedbackId}
                                    >
                                      {this.state.feedbackId}
                                    </td>
                                    <td className="col-10  mt-2 border-left border-bottom pl-10 pb-20 pr-10">
                                      <div className="text-12-normal-400">
                                        Any other feedback
                                      </div>
                                      <textarea
                                        className={`text-wrap form-text-box2 feedback resize-none border-radius-0 ${isMobile
                                          ? "form-control form-control-mobile"
                                          : "form-control"
                                          }`}
                                        rows="3"
                                        value={this.state.comments}
                                        onChange={(e) => {
                                          if (isCourseSubmit == false) {
                                            this.setState({
                                              comments: e.target.value,
                                            });
                                          }
                                        }}
                                      // readOnly = {this.state.isCourseSubmit}
                                      >
                                        {this.state.comments}
                                      </textarea>
                                    </td>
                                    <td className=" col-1 border-bottom border-right pr-catalogue"></td>
                                  </tr>
                                </tbody>
                              </tabel>
                            )} */}
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className={` ${isMobile ? "mt-2" : ""} `}>
                    <input
                      type="checkbox"
                      name="terms"
                      value="CQ"
                      checked={isCQApplicable == false}
                      onClick={() => {
                        {
                          this.handleCheckbox("CQ");
                        }
                      }}
                    ></input>
                    <span className="mx-2  text-12-bold">
                      CQ not applicable
                    </span>
                  </div>

                  <div className="row mt-1">
                    <div
                      className={`${iswebMobile ? "col-12" : "col-6 pl-0"
                        } col-sm-7 col-md-7 col-lg-7 col-xl-7 mb-3  ${iswebMobile
                          ? "mt-2"
                          : isMobile
                            ? "mt-4 ml-8"
                            : "mt-2 ml-8"
                        } `}
                    >
                      <button
                        className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`}
                        onClick={() => {
                          if (
                            this.state.courseAdd?.length > 0 ||
                            isCQApplicable
                          ) {
                            this.courseAddSubmit();
                          }
                        }}
                      >
                        <CommonIcon
                          fileName="ButtonSubmitIcon"
                          className="modal-img"
                        ></CommonIcon>
                        <span className="model-label pl-5">
                          {(isCourseSubmit) ? "Update" : "Submit"}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {isPte && (
              <div>
                {(isPteApplicable == true || isPteApplicable == null) && (
                  <>
                    <div className="row">
                      <div
                        className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                          } `}
                      >
                        <button
                          className={` pte-label-button label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <label>
                            <CommonIcon fileName="skillKonwIcon" />
                            <span className="pl-5 properties-span-2">
                              Skill and Knowledge Evaluation
                            </span></label>
                        </button>
                        <button
                          className={`btn pte-add-button`}
                          onClick={() => {
                            {
                              this.addRow("PTE");
                            }
                          }}
                        >
                          <CommonIcon
                            fileName="vendoraddIcon"
                            className="modal-img"
                          />
                          <span className="model-label1 pl-5">Add</span>
                        </button>
                      </div>

                      {/* table */}
                      <div className={` mt-2 ${isMobile ? "" : "pb-3"}`}>
                        <div className={`${isMobile && "table-responsive table-responsive-scroll"}`}>
                          <table className="postskill-table-width">
                            <thead>
                              <tr className="border-top height-course">
                                <th className=" slno-pte text-12-bold border-right border-left pl-5px">
                                  S.no
                                </th>
                                <th className="levelofskill text-12-bold border-right border-left pl-5px">
                                  Level of Skill and knowledge (Pre-Training)
                                </th>
                                <th className="skill-box text-12-bold border-right border-left pl-5px">
                                  Skills & knowledge
                                </th>
                                <th className="levelofskill text-12-bold border-left pl-5px">
                                  Level of Skill and knowledge (Post-Training)
                                </th>
                                <th className="border-right"></th>
                              </tr>
                            </thead>
                            <tbody className="border-bottom text-12-normal-400">
                              {this.state.PTE?.length > 0 ? (
                                this.state.PTE.map((item, index) => (
                                  <tr key={index + "PTE"}>
                                    <td className=" text-12-bold border-right border-left pl-10 pb-95">
                                      {index + 1}
                                    </td>
                                    <td
                                      className={` pl-10 pb-20 text-wrap ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {this.state.pteAnswersOption?.map((pteOption1) => (
                                        <>
                                          <input
                                            className="height"
                                            type="radio"
                                            name="test"
                                            disabled
                                          />
                                          <label
                                            className={`${isMobile ? "pl-3" : "pl-10"
                                              }`}
                                          >
                                            {pteOption1?.name}
                                          </label>
                                          <br />
                                        </>
                                      ))}


                                    </td>
                                    <td className="mt-1 border-right border-left pl-10 pr-10 pb-20">
                                      <textarea
                                        className={`text-wrap form-text-box2 resize-none border-radius-0 ${isMobile
                                          ? "form-control form-control-mobile"
                                          : "form-control"
                                          }`}
                                        rows="3"
                                        style={{
                                          borderColor:
                                            this.state.emptyId?.includes(index)
                                              ? "#d12232"
                                              : "",
                                        }}
                                        onChange={(e) =>
                                          this.pteAddQuestions(e, index)
                                        }
                                        value={item.question}
                                      // readOnly = {this.state.isPteSubmit}
                                      >
                                        {item.question}
                                      </textarea>
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {this.state.pteAnswersOption?.map((pteOption, index) => (
                                        <>
                                          <input
                                            className="height"
                                            type="radio"
                                            name="test"
                                            disabled
                                          />
                                          <label
                                            className={`${isMobile ? "pl-3" : "pl-10"
                                              }`}
                                          >
                                            {pteOption?.name}
                                          </label>
                                          <br /></>
                                      ))}


                                    </td>
                                    <td className="border-right pl-10 pb-95">
                                      <button
                                        className={`text-reset offcavasclose small-cross-icon-pte ${isMobile ? "pr-0" : ""
                                          }`}
                                        onClick={() => {
                                          {
                                            this.removeRow(index, "PTE");
                                          }
                                        }}
                                      >
                                        {this.state.PTE?.length > 1 &&
                                          <CommonIcon
                                            fileName="smallCrossIcon"
                                            className={`cursor-pointer ${isMobile ? "" : " app-image-hover"
                                              }`}
                                          />}
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="border-right border-left"></td>
                                  <td
                                    colSpan={7}
                                    className="table-nodata text-center border-right p-2"
                                  >
                                    {"No record found"}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                          } `}
                      >
                        <button
                          className={`pte-label-button label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon fileName="jobIcon" />
                          <span className="pl-5 properties-span-2">
                            List of Job/Task/Activity Undertake After Completing
                            Training
                          </span>
                        </button>
                        <button
                          className={`btn pte-add-button`}
                          onClick={() => {
                            {
                              this.addRow("PTEJOB");
                            }
                          }}
                        >
                          <CommonIcon
                            fileName="vendoraddIcon"
                            className="modal-img"
                          />
                          <span className="model-label1 pl-5">Add</span>
                        </button>
                      </div>

                      <div className={` mt-2 ${isMobile ? "" : "pb-3"}`}>
                        <div
                          className={`${isMobile && "table-responsive table-responsive-scroll"} mt-20`}
                        >
                          <table className="pte-table-width text-12-normal-400">
                            <thead>
                              <tr className="border-top height-course">
                                <th className=" skill-slno text-12-bold border-right border-left pl-5px">
                                  S.no
                                </th>
                                <th className="skill-box text-12-bold border-right border-left pl-5px">
                                  Job / Task / Activity
                                </th>
                                <th className="levelofskill text-12-bold  border-left pl-5px status-pte">
                                  Status
                                </th>
                                <th className="border-right"></th>
                              </tr>
                            </thead>
                            <tbody className="border-bottom">
                              {this.state.pteJob?.length > 0 ? (
                                this.state.pteJob?.map((item, index) => (
                                  <tr key={index + "PTEJOB"}>
                                    <td className="mt-1 text-12-bold border-right border-left pl-10 pb-50">
                                      {index + 1}
                                    </td>
                                    <td className="mt-1 border-right border-left pl-10 pr-10 pb-20">
                                      <textarea
                                        className={`text-wrap form-text-box3 resize-none border-radius-0 ${isMobile
                                          ? "form-control form-control-mobile"
                                          : "form-control"
                                          }`}
                                        rows="3"
                                        style={{
                                          borderColor:
                                            this.state.jobEmptyId?.includes(
                                              index
                                            )
                                              ? "#d12232"
                                              : "",
                                        }}
                                        onChange={(e) =>
                                          this.pteAddJobQuestions(e, index)
                                        }
                                        value={item.question}
                                      // readOnly = {this.state.isPteSubmit}
                                      >
                                        {item.question}
                                      </textarea>
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {this.state.pteJobAnswerOption?.map((pteJobOption) => (
                                        <>
                                          <input
                                            className="height"
                                            type="radio"
                                            name="test"
                                            disabled
                                          />
                                          <label
                                            className={`${isMobile ? "pl-3" : "pl-10"
                                              }`}
                                          >
                                            {pteJobOption?.name}
                                          </label>
                                          <br />
                                        </>
                                      ))}
                                    </td>
                                    <td className="border-right pl-10 pb-50 pr-10">
                                      <button
                                        className={`text-reset offcavasclose small-cross-icon-pte ${isMobile ? "pr-0" : ""
                                          }`}
                                        onClick={() => {
                                          {
                                            this.removeRow(index, "PTEJOB");
                                          }
                                        }}
                                      >
                                        <CommonIcon
                                          fileName="smallCrossIcon"
                                          className={`cursor-pointer ${isMobile ? "" : " app-image-hover"
                                            }`}
                                        />
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="border-right border-left"></td>
                                  <td
                                    className="table-nodata text-center border-right border-left p-2"
                                  >
                                    {isEdit && "No record found"}
                                    {isAdd && "No record to Add"}
                                  </td>
                                  <td></td>
                                  <td className="border-right"></td>
                                </tr>
                              )}
                              {/* <tr>
                                              <td></td>
                                              <td>
                                                {jobEmptyId?.length > 0 ? (
                                                  <span className="send-rework-label">
                                                    All field is required
                                                  </span>
                                                ) : (
                                                  <></>
                                                )}
                                              </td>
                                            </tr> */}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className={` ${isMobile ? "mt-2" : ""} `}>
                  <input
                    type="checkbox"
                    name="terms"
                    value="PTE"
                    checked={isPteApplicable == false}
                    onClick={() => {
                      {
                        this.handleCheckbox("PTE");
                      }
                    }}
                  ></input>
                  <span className="mx-2  text-12-bold">PTE not applicable</span>
                </div>
                {
                  <div className="row mt-1">
                    <div
                      className={`${iswebMobile ? "col-12" : "col-6 pl-0"
                        } col-sm-7 col-md-7 col-lg-7 col-xl-7 mb-3 ${iswebMobile
                          ? "mt-2"
                          : isMobile
                            ? "mt-4 ml-8"
                            : "mt-2 ml-8"
                        } `}
                    >
                      {/* // isAdd && 
                    // <button className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`} onClick={() => {if(this.state.PTE?.length > 0 && this.state.pteJob?.length > 0){this.pte1Submit()}}}> */}
                      {/* <CommonIcon fileName="NextArrowIcon" className="modal-img"></CommonIcon> */}
                      {/* <span className="model-label pl-5">Next</span>
                    <span className="mx-2"><CommonIcon fileName="NextArrowIcon" className="modal-img"></CommonIcon></span>
                </button>
                   } */}
                      <button
                        className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`}
                        onClick={() => {
                          if (this.state.PTE?.length > 0) {
                            this.pte1Submit();
                          }
                        }}
                      >
                        <CommonIcon
                          fileName="ButtonSubmitIcon"
                          className="modal-img"
                        ></CommonIcon>
                        <span className="model-label pl-5">
                          {(isPteSubmit) ? "Update" : "Submit"}
                        </span>
                        {/* <span className="mx-2"><CommonIcon fileName="NextArrowIcon" className="modal-img"></CommonIcon></span> */}
                      </button>
                    </div>
                  </div>
                }
              </div>
            )}
          </div>
        </div>

        <div
          className="offcanvas offcanvas-end offcanvasStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="searchScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"
              }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title fw-600">
              Search
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : "pr-0"
                }`}
              data-bs-dismiss="offcanvas"
              // id="closeButton"
              onClick={this.closeSearchScreen}
            >
              <CommonIcon fileName="CrossIcon" />
            </button>
            <button
              className="display-none"
              id="closeButton"
              data-bs-dismiss="offcanvas"
            >
            </button>
          </div>
          <div className="offcanvas-body px-4 pt-0">
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}
              >
                <div className="form-group">
                  <div className="row">
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                        }`}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text pb-1 ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="CourseCodeIcon"
                          />{" "}
                          <span className="pl-5 properties-span-2">
                            Course code
                          </span>
                          &nbsp;
                          <label className="required"></label>
                        </label>
                        <input
                          type="text"
                          className="form-control form-text-box my-input-class input-box-masterdata"
                          id="courseCode"
                          autocomplete="off"
                          value={this.state.courseCodeSearch}
                          onChange={(e) => { this.setState({ courseCodeSearch: e.target.value }) }
                          }
                        />
                      </div>
                    </div>
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                        }`}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="CourseTitleIcon"
                          />{" "}
                          <span className="pl-5 properties-span-2 ">
                            Course title
                          </span>
                          <label className="required"></label>
                        </label>
                        <input
                          type="text"
                          className="form-control form-text-box my-input-class input-box-masterdata"
                          id="courseTitle"
                          value={this.state.courseTitleSearch}
                          onChange={(e) => { this.setState({ courseTitleSearch: e.target.value }) }
                          }
                        />
                      </div>
                    </div>
                    {/* <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                        }`}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="courseDuration"
                          />{" "}
                          <span className="pl-5 properties-span-2 ">
                            Course provider
                          </span>
                          <label className="required"></label>
                        </label>
                        <input
                          type="text"
                          className="form-control form-text-box my-input-class input-box-masterdata"
                          id="courseDuration"
                          value={this.state.courseProviderSearch}
                          placeholder=""
                          onChange={(e) => this.setState({ courseProviderSearch: e.target.value })}
                        />
                      </div>
                    </div> */}

                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                      <div className="form-group">
                        <label
                          className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                          <CommonIcon
                            className="properties-img-2"
                            fileName="courseDuration"
                          />{" "}
                          <span className="pl-7 properties-span-2">Course provider</span>
                        </label>
                        <Select
                          className={`text-12-normal-select my-input-class`}
                          classNamePrefix="assigngroups"
                          placeholder="Please select an option"
                          value={this.state.vendorSearch}
                          options={this.state.vendorNameList}
                          // defaultValue={this.state.selectVendorName || "Select"}
                          isClearable={true}
                          isMulti={false}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          isSearchable={true}
                          onChange={(e) => this.setState({ vendorSearch: e })}
                        />

                      </div>
                    </div>
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                        } `}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="skillIcon"
                          />{" "}
                          <span className="pl-5 properties-span-2">
                            Skill
                          </span>
                          <label className="required"></label>
                        </label>
                        <Select
                          className="text-12-normal-select my-input-class"
                          classNamePrefix="assigngroups"
                          value={this.state.skillSearch}
                          options={this.state.skillTypeList}
                          placeholder="Please select an option"
                          // defaultValue={this.state.skillTypeDefault}
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          styles={styles}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          // styles={this.state.skillTypeError && customStyles}
                          // isDisabled = {isSubmitTrue}
                          onChange={(e) => this.setState({ skillSearch: e })} //ArunPending
                        />
                      </div>
                    </div>
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                        } `}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="courseCategoryIcon"
                          />{" "}
                          <span className="pl-7 properties-span-2">
                            Category 1
                          </span>
                          <label className="required"></label>
                        </label>
                        <Select
                          className="text-12-normal-select my-input-class"
                          classNamePrefix="assigngroups"
                          value={this.state.category1Search}
                          options={this.state.category1List}
                          placeholder="Please select an option"
                          // defaultValue={this.state.category1Default}
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          styles={styles}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          // styles={this.state.category1Error && customStyles}
                          // isDisabled = {isSubmitTrue}
                          onChange={this.handleCategory1} //ArunPending
                        />
                      </div>
                    </div>
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                        } `}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 pb-1 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="courseCategoryIcon"
                          />{" "}
                          <span className="pl-7 properties-span-2">
                            Category 2
                          </span>
                          <label className="required"></label>
                        </label>
                        <Select
                          className="text-12-normal-select my-input-class"
                          classNamePrefix="assigngroups"
                          value={this.state.category2Search}
                          options={this.state.category2List}
                          placeholder="Please select an option"
                          isMulti={false}
                          isSearchable={true}
                          isClearable={true}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          onChange={this.handleCategory2} //ArunPending
                          isDisabled={this.state.category1Search ? false : true}
                        />

                      </div>
                    </div>
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                        }`}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text pb-1 ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="MyselfIcon"
                          />{" "}
                          <span className="pl-5 properties-span-2">
                            Course status
                          </span>
                          &nbsp;
                          <label className="required"></label>
                        </label>
                        <input
                          type="text"
                          className="form-control form-text-box my-input-class input-box-masterdata"
                          value={this.state.courseStatusSearch}
                          placeholder=""
                          onChange={(e) => { this.setState({ courseStatusSearch: e.target.value }) }
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
            {/* {(isSkillEmpty || isJobEmpty || isLevelEmpty || isProficiencyEmpty) ? (
                      <span className="send-rework-label">This field is required</span>
                    ) : (<></>)} */}
            {this.state.isFieldEmpty && (
              <span className="send-rework-label">
                Atleast one field is required
              </span>
            )}

            <div className="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
              <button
                className="btn rejectbutton"
                onClick={() => this.clearSearchFields()}
              >
                <CommonIcon
                  className="button-img"
                  fileName="ButtonRejectApprovalIcon"
                />
                <span className="px-1">Clear</span>
              </button>
              {/* <button className="btn approvebutton mx-2" onClick={() => this.searchCourseMasterList()}><CommonIcon className="button-img" fileName="searchIcon" /><span className="pl-10">Search</span></button> */}
              <button
                className={`btn approvebutton d-flex gap-1 mx-2`}
                onClick={() => this.searchCourseMasterList()}
              >
                <span>
                  <CommonIcon fileName="searchableIcon" />
                </span>
                <span className="model-label pl-vendor3 pl-2">Search</span>
              </button>
            </div>
          </div>
        </div>

        {/* Modal - Warning */}
        <div
          className="modal fade modal-style"
          id="switchTabWarningScreen"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header pb-2 pl-20">
                <h5
                  className="modal-title d-flex pl-10"
                  id="exampleModalLongTitle"
                >
                  <CommonIcon fileName="WarningIcon" />
                  &nbsp;<span className="mt-1 pl-5"></span>Warning
                </h5>
              </div>
              <div className="modal-body pl-20">
                <h5 className="warning-text">
                  {"You cannot proceed without submitting the course."}
                </h5>
              </div>
              <div className="modal-footer border-top-none justify-content-center pb-3">
                {/* <button className={`btn input-group ${isMobile ? "warning-btn-mobile" : "rejectbutton"}`} data-bs-dismiss="modal" onClick={this.closeCourse}>Close </button> */}
                <button
                  className={`btn input-group ${isMobile ? "filter-nextMobilebtn" : "approvebutton"
                    }`}
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <WarningComponent
          message={
            "The changes will be discarded.Are you sure you want to close?"
          }
          isMobile={this.state.isMobile}
          onYesClick={() => this.closeCourse()}
        />

        {/* Pagination */}
        <PaginationComponent
          fetchPagination={this.fetchPaginationList}
          pageCount={pageCount} reset={this.state.pageNewCount}
        />
        <CommonCloneModal
          isMobile={this.state.isMobile}
          roleId={this.state.cloneId}
          cloneSuccess={() => this.cloneSuccess()}
          isCourse={true}
        />
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Coursemaster)
);
